(function() {
  'use strict';

  const RETAIL_SUFFIX = window.QuickviewConfig?.retailSuffix || '-r';
  const TRANSLATIONS = window.QuickviewConfig?.translations || {};

  let currentProduct = null;
  let currentVariants = [];
  let selectedColor = null;
  let selectedGroup = null;
  let customerTags = [];
  let setDistribution = {};
  let maxSets = 0;
  let isWholesale = false;

  // ✅ KAT SAYI: İç giyim için kat sayı modu
  let katSayi = 0;
  let isKatSayiMode = false;
  let selectedKatSayiSize = null; // Kat Sayı modunda seçilen beden

  // Retail/Wholesale switching
  let wholesaleProduct = null;
  let retailProduct = null;
  let wholesaleHandle = null;
  let retailHandle = null;
  let hasRetailVersion = false;

  // Multi-asorti support
  let baseStokKodu = null;           // Ürünün stokkodu (handle'dan)
  let availableAsortis = [];         // Bulunan asortiler [{kod: 'a', handle: '123-a', product: {...}, setContent: '...'}, ...]
  let currentAsortiKod = null;       // Şu anki asorti kodu

  // KZK Ic Giyim - Cup variant support (sutyenler)
  // Barkod ilk 2 hane: 33=B, 34=C, 35=D, 37=E, 38=F (36 yok)
  const KZK_CUP_BARKOD_MAP = { '33':'B','34':'C','35':'D','37':'E','38':'F' };
  const KZK_CUP_HANES = Object.keys(KZK_CUP_BARKOD_MAP);
  let currentCupHane = null;          // Su anki urunun hanesi (varsa, '33'-'38')
  let cupBaseModel = null;            // Hane'siz model + asorti suffix (ornek: '70570000' veya '60010000-a')
  let availableCups = [];             // [{hane:'34', cup:'C', handle:'3470570000', product:{...}}, ...]
  let kzkAdimPaketleme = false;       // 1. adim: paketleme secildi mi (eski akis: ayri -a urunu)
  let kzkAdimCup = false;             // 2. adim: cup secildi mi
  // KZK model urun (2026-09): Cup ayni urunun 'Cup' secenegi, askili+kutulu stogu birlesik.
  // Akis: cup -> renk x beden matrisi -> en sonda paketleme (sepete 'Paketleme' satir ozelligi).
  let cupOption = null;               // Urunde 'Cup' secenegi varsa {name, position}
  let paketSecenekleri = [];          // paket:askili / paket:kutulu etiketlerinden: ['askili','kutulu']
  let secilenPaket = null;            // 'askili' | 'kutulu'

  // DOM Elements
  let overlay, modal, loading, productSection;
  let wholesaleSection, retailSection;

  // Initialize
  function init() {
    overlay = document.getElementById('quickview-modal-overlay');
    if (!overlay) return;

    modal = overlay.querySelector('.qv-modal');
    loading = overlay.querySelector('.qv-loading');
    productSection = overlay.querySelector('.qv-product');
    wholesaleSection = overlay.querySelector('.qv-wholesale-section');
    retailSection = overlay.querySelector('.qv-retail-section');

    // ✅ Get customer tags for group pricing
    if (window.customerData && window.customerData.tags) {
      customerTags = window.customerData.tags;
      log('Customer tags loaded:', customerTags);
    }

    bindEvents();
    log('Quickview Modal initialized');

    // KZK: Inline mode (urun sayfasi) — overlay'i mount div'ine tasi + auto-open
    if (window.__qvInlineHandle) {
      setupInlineMode(window.__qvInlineHandle);
    }
  }

  // ─── KZK Inline Mode (urun sayfasinda popup yerine sayfa icinde render) ───
  let __qvInlineActive = false;
  async function setupInlineMode(handle) {
    const mount = document.getElementById('qv-inline-mount');
    if (!mount || !overlay) return;
    try {
      __qvInlineActive = true;
      // Overlay element'ini mount div'ine tasi
      mount.appendChild(overlay);
      overlay.classList.add('qv-inline');
      overlay.classList.add('qv-active');
      overlay.style.display = 'flex';
      // Otomatik urun yukle
      await openModal(handle);
      // openModal sonunda display'i koru
      overlay.style.display = 'flex';
      overlay.classList.add('qv-active');
    } catch (e) {
      log('Inline setup error:', e.message);
    }
  }

  // Bind Events
  function bindEvents() {
    // Close modal
    overlay.querySelector('.qv-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('qv-active')) {
        closeModal();
      }
    });

    // Listen for quickview trigger clicks (capture phase to override theme handlers)
    document.addEventListener('click', (e) => {
      // 1. Direkt quickview trigger (bizim kucuk goz iconu)
      let trigger = e.target.closest('[data-quickview-handle]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const handle = trigger.dataset.quickviewHandle;
        if (handle) openModal(handle);
        return;
      }

      // 2. KZK: Theme quick-add / quick-shop butonlari (data-product-url ile)
      trigger = e.target.closest('.js-quick-add[data-product-url], .quick-add-btn[data-product-url], button[data-product-url]');
      if (trigger) {
        const url = trigger.dataset.productUrl || trigger.getAttribute('data-product-url') || '';
        const m = url.match(/\/products\/([^?#]+)/);
        if (m && m[1]) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          openModal(m[1]);
          return;
        }
      }

      // 3. KZK: <quick-add> web component icindeki butonlar (urun handle'a sahip card)
      trigger = e.target.closest('quick-add button, .card__quick-add button');
      if (trigger) {
        const card = trigger.closest('product-card, .product-card, .card, [data-product-handle]');
        let handle = card?.dataset?.productHandle;
        if (!handle) {
          const link = card?.querySelector('a[href*="/products/"]');
          const url = link?.href || link?.getAttribute('href') || '';
          const m = url.match(/\/products\/([^?#]+)/);
          if (m) handle = m[1];
        }
        if (handle) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          openModal(handle);
        }
      }
    }, true);

    // Wholesale quantity controls
    const wholesaleQtyControls = wholesaleSection.querySelector('.qv-quantity-controls');
    if (wholesaleQtyControls) {
      wholesaleQtyControls.querySelector('.qv-qty-minus').addEventListener('click', () => updateSetQuantity(-1));
      wholesaleQtyControls.querySelector('.qv-qty-plus').addEventListener('click', () => updateSetQuantity(1));
      wholesaleQtyControls.querySelector('.qv-qty-input').addEventListener('change', (e) => {
        const val = parseInt(e.target.value) || 1;
        setSetQuantity(val);
      });
    }

    // Wholesale add to cart
    overlay.querySelector('.qv-add-wholesale')?.addEventListener('click', addWholesaleToCart);

    // Retail add to cart
    overlay.querySelector('.qv-add-retail')?.addEventListener('click', addRetailToCart);

    // Mode toggle buttons
    overlay.querySelector('.qv-mode-wholesale')?.addEventListener('click', () => switchMode('wholesale'));
    overlay.querySelector('.qv-mode-retail')?.addEventListener('click', () => switchMode('retail'));

    // Detayli sepete ekleme (sadece tekleme modu)
    overlay.querySelector('.qv-detailed-open-btn')?.addEventListener('click', openDetailedMode);
    overlay.querySelector('.qv-detailed-back-btn')?.addEventListener('click', closeDetailedMode);
    overlay.querySelector('.qv-detailed-add-btn')?.addEventListener('click', submitDetailedCart);
  }

  // ---------- DETAYLI SEPETE EKLEME (Matrix Mode) ----------
  let detailedSelectedCup = null;

  // Magazada etiket yazimi tutarsiz: 'icgiyim', 'İç Giyim', 'ic giyim' hepsi ayni sey.
  // Turkce harfler ve ayiricilar sadelestirilip karsilastirilir.
  function normTag(v) {
    return String(v == null ? '' : v)
      .toLowerCase()
      .replace(/̇/g, '')
      .replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ı/g, 'i')
      .replace(/ö/g, 'o').replace(/ş/g, 's').replace(/ü/g, 'u')
      .replace(/[\s_-]/g, '');
  }

  function isUnderwearProduct() {
    if (!currentProduct) return false;
    const t = currentProduct.tags;
    const list = Array.isArray(t)
      ? t
      : (typeof t === 'string' ? t.split(',') : []);
    return list.some(x => normTag(x) === 'icgiyim');
  }

  /** paket:askili / paket:kutulu etiketleri -> ['askili','kutulu'] (senkron yazar; sira sabit) */
  function paketEtiketleriOku(tags) {
    const list = Array.isArray(tags) ? tags : (typeof tags === 'string' ? tags.split(',') : []);
    const set = new Set(list.map(x => String(x).trim().toLowerCase()));
    const out = [];
    if (set.has('paket:askili')) out.push('askili');
    if (set.has('paket:kutulu')) out.push('kutulu');
    return out;
  }
  const paketAdi = (p) => (p === 'kutulu' ? 'Kutulu' : 'Askılı');

  /** Etkin adim: kutulu her zaman 1 (beden bazli serbest adet); askili urunun kat sayisi (2'li paket -> 2).
   *  Iki paketleme secilebilir ve henuz secilmemisse 1 (askili secilince adetler kat sayisina yuvarlanir). */
  function etkinAdim(katSayiUrun) {
    const kat = katSayiUrun > 1 ? katSayiUrun : 1;
    if (!paketSecenekleri.length) return kat;
    if (secilenPaket === 'kutulu') return 1;
    if (secilenPaket === 'askili') return kat;
    return paketSecenekleri.length === 1 && paketSecenekleri[0] === 'askili' ? kat : 1;
  }

  /** Matrisin altindaki paketleme secimi (model urun akisi). Tek secenek varsa otomatik secilir. */
  function renderDetailedPaketRow() {
    const row = overlay.querySelector('.qv-detailed-paket-row');
    const box = overlay.querySelector('.qv-detailed-paket-options');
    if (!row || !box) return;
    box.innerHTML = '';
    if (!paketSecenekleri.length) { row.style.display = 'none'; return; }
    if (paketSecenekleri.length === 1) secilenPaket = paketSecenekleri[0];
    const ilkInput = overlay.querySelector('.qv-detailed-input');
    const katSayiUrun = ilkInput ? (parseInt(ilkInput.dataset.kat) || 1) : 1;
    paketSecenekleri.forEach(p => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'qv-pkg-btn' + (secilenPaket === p ? ' is-active' : '');
      b.textContent = paketAdi(p) + (p === 'askili' && katSayiUrun > 1 ? ` (${katSayiUrun}'li paket)` : '');
      if (paketSecenekleri.length === 1) { b.disabled = true; b.title = 'Bu üründe tek paketleme seçeneği var'; }
      b.addEventListener('click', () => {
        secilenPaket = p;
        box.querySelectorAll('.qv-pkg-btn').forEach(x => x.classList.toggle('is-active', x === b));
        updateDetailedTotals({ type: 'change' });
      });
      box.appendChild(b);
    });
    row.style.display = '';
  }

  function showDetailedButton() {
    const btn = overlay.querySelector('.qv-detailed-open-btn');
    if (!btn) return;
    // Sadece tekleme modu + birden fazla renk varsa anlamli (tek renk varsa zaten standart akis yeter)
    const colorOption = currentProduct ? findOptionByType(currentProduct.options, ['color', 'colour', 'renk']) : null;
    const colorCount = colorOption ? (colorOption.values || []).length : 1;
    btn.style.display = (!isWholesale && colorCount >= 1) ? 'block' : 'none';
  }

  function openDetailedMode() {
    overlay.querySelector('.qv-retail-section').style.display = 'none';
    overlay.querySelector('.qv-color-selector').style.display = 'none';
    const sec = overlay.querySelector('.qv-detailed-section');
    sec.style.display = 'block';
    renderDetailedSection();
  }

  function closeDetailedMode() {
    overlay.querySelector('.qv-detailed-section').style.display = 'none';
    overlay.querySelector('.qv-retail-section').style.display = '';
    const colorSelector = overlay.querySelector('.qv-color-selector');
    if (colorSelector && currentProduct) {
      // Sadece renk secimi mevcutsa goster
      const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);
      if (colorOption && (colorOption.values || []).length > 1) colorSelector.style.display = '';
    }
  }

  /** 'Set İçeriği: 85=2|90=2|95=1|100=1' -> { '85':2, '90':2, '95':1, '100':1 }
   *  Sayisal bedenlerde (85/90/100) eski parser calismadigi icin bu bicim kullanilir.
   *  Eslesme yoksa null doner, cagiran taraf eski parser'a duser. */
  function parseSetIcerigiPairs(desc) {
    if (!desc) return null;
    const txt = String(desc).replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ');
    const m = txt.match(/Set\s*İ[çc]eri[ğg]i\s*[:：]\s*([^<\n]{1,160})/i);
    if (!m) return null;
    const dagilim = {};
    let sayi = 0;
    m[1].split('|').forEach(par => {
      const k = par.trim().match(/^([^=\s]+)\s*=\s*(\d+)$/);
      if (k && parseInt(k[2], 10) > 0) { dagilim[k[1]] = parseInt(k[2], 10); sayi++; }
    });
    return sayi >= 2 ? dagilim : null;
  }

  /** Lot etiketi: once beden dagilimi, yoksa 'Lot: N' - baslikta gecen '(Lotlu)' yakalanmaz. */
  function parseLotFromDescription(desc) {
    if (!desc) return '';
    const dagilim = parseSetIcerigiPairs(desc);
    if (dagilim) {
      return Object.entries(dagilim).map(x => x[0] + 'x' + x[1]).join(' / ').slice(0, 60);
    }
    const txt = String(desc).replace(/<[^>]+>/g, ' ');
    const m = txt.match(/\bLot\s*[:：]\s*(\d[0-9\-x|= \t]*)/i);
    if (m && m[1]) return m[1].trim().slice(0, 40);
    return '';
  }

  function renderDetailedSection() {
    const rowsContainer = overlay.querySelector('.qv-detailed-rows');
    const cupRow = overlay.querySelector('.qv-detailed-cup-row');
    const cupOptions = overlay.querySelector('.qv-detailed-cup-options');
    rowsContainer.innerHTML = '';
    cupOptions.innerHTML = '';

    if (!currentProduct) return;

    const bilgiKutusu = (metin) => {
      rowsContainer.innerHTML =
        '<div style="text-align:center;padding:18px;color:#6b7280;font-size:14px">' + metin + '</div>';
    };

    // 1. ADIM (eski akis, ayri -a urunu): paketleme secilmeden cup ve matris gosterilmez.
    // Model urunde (paket etiketi var) paketleme en sonda secilir, bu adim atlanir.
    if (!kzkAdimPaketleme && !paketSecenekleri.length) {
      cupRow.style.display = 'none';
      bilgiKutusu('Önce paketleme seçin.');
      return;
    }

    // Cup secimi: sadece icgiyim + birden fazla cup varsa
    const isUnderwear = isUnderwearProduct();
    if (isUnderwear && availableCups && availableCups.length > 1) {
      cupRow.style.display = '';
      availableCups.forEach(c => {
        const b = document.createElement('button');
        b.type = 'button';
        const anahtar = c.option ? c.deger : c.hane;
        b.textContent = c.option ? String(c.cup).replace(/\s*Cup$/i, '') : c.cup;
        b.dataset.cupKey = anahtar;
        // Eski akista bulundugumuz cup hatirlanir ama GORSEL olarak secili gosterilmez:
        // musteri kendi secene kadar hicbiri isaretli degil.
        if (!c.option && !detailedSelectedCup && c.hane === currentCupHane) {
          detailedSelectedCup = c.hane;
        }
        if (kzkAdimCup && detailedSelectedCup === anahtar) {
          b.classList.add('is-active');
        }
        b.addEventListener('click', async () => {
          kzkAdimCup = true;
          if (anahtar === detailedSelectedCup) { renderDetailedSection(); return; }
          detailedSelectedCup = anahtar;
          if (!c.option && c.hane !== currentCupHane && c.handle) {
            await switchCup(c.hane, c.handle);
          }
          renderDetailedSection();
        });
        cupOptions.appendChild(b);
      });
    } else {
      cupRow.style.display = 'none';
      kzkAdimCup = true; // secilecek cup yok
      if (cupOption && availableCups.length === 1) detailedSelectedCup = availableCups[0].deger;
    }

    // 2. ADIM: cup secilmeden matris gosterilmez
    if (!kzkAdimCup) {
      bilgiKutusu('Cup seçin.');
      return;
    }

    const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);
    const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
    const groupOption = findOptionByType(currentProduct.options, ['fiyat grubu', 'fiyat', 'grup', 'group', 'price', 'pricing']);

    if (!sizeOption) {
      rowsContainer.innerHTML = '<div style="text-align:center;padding:20px;color:#6b7280">Bu üründe beden seçimi yok</div>';
      return;
    }

    const colors = colorOption ? getOptionValues(colorOption.position) : [{ value: '__single__' }];
    const sizes = bedenleriSirala(getOptionValues(sizeOption.position));
    const lot = isUnderwearProduct() ? '' : parseLotFromDescription(currentProduct.description);
    // Kat Sayi (urun): aciklamadaki 'Kat Sayı: N'. Adim, secilen paketlemeye gore etkinAdim() ile hesaplanir
    // (kutulu 1; askili N). Paketleme secilmeden once adim 1'dir, askili secilince adetler N'in katina yuvarlanir.
    let katSayiUrun = katSayi > 1 ? katSayi : 1;
    if (katSayiUrun <= 1 && currentProduct && currentProduct.description) {
      const cleanDesc = String(currentProduct.description).replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ');
      const km = cleanDesc.match(/Kat\s*Say[ıi]\s*[:：]?\s*(\d+)/i);
      if (km) katSayiUrun = parseInt(km[1]) || 1;
    }
    let basilanRenk = 0;
    // Secili cup harfi beden yaninda yazilir (80 -> 80D): musteri hangi cup'ta adet girdigini gorsun
    const cupHarfi = cupOption
      ? (detailedSelectedCup ? String(detailedSelectedCup).replace(/\s*Cup$/i, '').trim() : '')
      : ((isUnderwear && currentCupHane && KZK_CUP_BARKOD_MAP[currentCupHane]) || '');

    colors.forEach(colorData => {
      const colorName = colorData.value === '__single__' ? '' : colorData.value;
      const colorVariants = currentVariants.filter(v => {
        let match = true;
        if (cupOption && detailedSelectedCup) match = match && v[`option${cupOption.position}`] === detailedSelectedCup;
        if (colorOption && colorName) match = match && v[`option${colorOption.position}`] === colorName;
        if (groupOption && selectedGroup) match = match && v[`option${groupOption.position}`] === selectedGroup;
        return match;
      });
      if (!colorVariants.length) return;

      // Bu renkteki ilk gorsel (renk-spesifik)
      const colorImg = (colorVariants.find(v => v.featured_image) || {}).featured_image;
      const imgUrl = colorImg ? (typeof colorImg === 'string' ? colorImg : (colorImg.src || colorImg.url || '')) : (currentProduct.featured_image || currentProduct.images?.[0] || '');

      // Stogu olmayan beden tabloda hic gosterilmez; bu renkte satilabilir beden
      // kalmadiysa renk satiri da basilmaz.
      const stokluBedenler = sizes.filter(sd => {
        const v = colorVariants.find(x => x[`option${sizeOption.position}`] === sd.value);
        return v && v.available && (v.inventory_quantity || 0) > 0;
      });
      if (!stokluBedenler.length) return;

      const row = document.createElement('div');
      row.className = 'qv-detailed-row';
      const sizeGridHtml = stokluBedenler.map(sd => {
        const variant = colorVariants.find(v => v[`option${sizeOption.position}`] === sd.value);
        const stock = variant ? (variant.inventory_quantity || 0) : 0;
        const available = variant && variant.available && stock > 0;
        const stockClass = !available ? 'is-out' : (stock <= 5 ? 'is-low' : '');
        const cellClass = !available ? 'qv-detailed-cell is-out' : 'qv-detailed-cell';
        const step = etkinAdim(katSayiUrun);
        // Ornek: katSayi=2, stock=435 -> max=434 (2'lik artislarla)
        const maxAllowed = available ? (Math.floor(stock / step) * step) : 0;
        const stockTxt = !available ? 'Stok yok' : `Stok: ${stock}`;
        return `
          <div class="${cellClass}">
            <div class="qv-detailed-cell__size">${escapeHtml(sd.value)}${cupHarfi ? `<span class="qv-detailed-cell__cup">${escapeHtml(cupHarfi)}</span>` : ''}</div>
            <div class="qv-detailed-cell__stock ${stockClass}">${stockTxt}</div>
            <input type="number" class="qv-detailed-input" min="0" max="${maxAllowed}" step="${step}" value="0"
                   data-variant-id="${variant ? variant.id : ''}"
                   data-price="${variant ? (variant.price || 0) : 0}"
                   data-step="${step}" data-kat="${katSayiUrun}" data-stock="${available ? stock : 0}"
                   ${available ? '' : 'disabled'}>
          </div>`;
      }).join('');

      row.innerHTML = `
        <div class="qv-detailed-row__visual">
          ${imgUrl ? `<img src="${escapeHtml(imgUrl)}" alt="${escapeHtml(colorName)}">` : ''}
          ${colorName ? `<div class="qv-detailed-row__color-name">Renk: ${escapeHtml(colorName)}</div>` : ''}
          ${lot ? `<div class="qv-detailed-row__lot">Lot: ${escapeHtml(lot)}</div>` : ''}
        </div>
        <div class="qv-detailed-row__sizes">${sizeGridHtml}</div>
      `;
      rowsContainer.appendChild(row);
      basilanRenk++;
    });

    if (!basilanRenk) {
      bilgiKutusu('Bu seçimde stokta ürün kalmadı.');
      renderDetailedPaketRow();
      return;
    }

    overlay.querySelectorAll('.qv-detailed-input').forEach(inp => {
      inp.addEventListener('input', updateDetailedTotals);
      inp.addEventListener('blur', updateDetailedTotals);
      inp.addEventListener('change', updateDetailedTotals);
    });
    // 3. ADIM (model urun): matrisin altinda paketleme secimi
    renderDetailedPaketRow();
    updateDetailedTotals();
  }

  function updateDetailedTotals(e) {
    // Yuvarlama SADECE input'tan cikinca (blur/change). 'input' event'inde
    // input.value'ya dokunmuyoruz - kullanici 54 yazmak isterse 5'i 4 yapma.
    const isCommit = e && (e.type === 'blur' || e.type === 'change');
    let totalCount = 0;
    let totalPriceCents = 0;
    overlay.querySelectorAll('.qv-detailed-input').forEach(inp => {
      const q = parseInt(inp.value) || 0;
      // Adim secilen paketlemeye gore degisir (kutulu 1, askili kat sayisi); max o adima gore yuvarlanir
      const step = etkinAdim(parseInt(inp.dataset.kat) || 1);
      const stock = parseInt(inp.dataset.stock || inp.max || 0);
      const max = Math.floor(stock / step) * step;
      if (String(inp.step) !== String(step)) { inp.step = step; inp.max = max; inp.dataset.step = step; }
      let qty = Math.max(0, q);
      if (step > 1 && qty > 0) {
        let rounded = Math.ceil(qty / step) * step;
        if (rounded > max) rounded = Math.floor(max / step) * step;
        qty = rounded;
      }
      qty = Math.min(qty, max);
      // Sadece commit (blur/change) anında input'a yaz - kullanici hala yaziyor olabilir
      if (isCommit && q !== qty) inp.value = qty;
      const price = parseInt(inp.dataset.price) || 0;
      // Total her zaman yuvarlanmis (gercekce sepete gidecek) miktari gosterir
      totalCount += qty;
      totalPriceCents += qty * price;
    });
    overlay.querySelector('.qv-detailed-total-count').textContent = `${totalCount} adet`;
    overlay.querySelector('.qv-detailed-total-price').innerHTML = formatMoney(totalPriceCents);
    const paketBekliyor = paketSecenekleri.length > 1 && !secilenPaket;
    const addBtn = overlay.querySelector('.qv-detailed-add-btn');
    addBtn.disabled = totalCount === 0 || paketBekliyor;
    addBtn.title = paketBekliyor && totalCount > 0 ? 'Önce paketleme seçin (Askılı / Kutulu)' : '';
    const msg = overlay.querySelector('.qv-detailed-msg');
    if (msg && !msg.dataset.sonuc) {
      msg.style.color = '';
      msg.textContent = paketBekliyor && totalCount > 0 ? 'Sepete eklemek için paketleme seçin.' : '';
    }
  }

  async function submitDetailedCart() {
    const btn = overlay.querySelector('.qv-detailed-add-btn');
    const msg = overlay.querySelector('.qv-detailed-msg');
    const items = [];
    // Paketleme sepet satirina ozellik olarak yazilir (sepette/siparişte gorunur, siparis API'si -A barkoda cevirir)
    const properties = secilenPaket ? { Paketleme: paketAdi(secilenPaket) } : null;
    overlay.querySelectorAll('.qv-detailed-input').forEach(inp => {
      const qty = parseInt(inp.value) || 0;
      const id = inp.dataset.variantId;
      if (qty > 0 && id) items.push(properties ? { id: Number(id), quantity: qty, properties } : { id: Number(id), quantity: qty });
    });
    if (!items.length) return;
    if (paketSecenekleri.length > 1 && !secilenPaket) {
      msg.style.color = '#dc2626';
      msg.textContent = 'Önce paketleme seçin (Askılı / Kutulu).';
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Ekleniyor...';
    msg.dataset.sonuc = '1';
    msg.style.color = '';
    msg.textContent = '';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        const errText = await res.text();
        throw new Error('Sepete eklenirken hata: ' + errText.slice(0, 120));
      }
      msg.style.color = '#16a34a';
      msg.textContent = `✓ ${items.reduce((s,i)=>s+i.quantity,0)} adet sepete eklendi`;
      btn.textContent = 'EKLENDİ ✓';
      // cart drawer refresh
      try {
        const cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.refresh === 'function') cd.refresh();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch {}
      setTimeout(() => {
        closeModal();
      }, 1400);
    } catch (err) {
      msg.style.color = '#dc2626';
      msg.textContent = err.message;
      delete msg.dataset.sonuc;
      btn.disabled = false;
      btn.textContent = 'SEPETE EKLE';
    }
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
  }

  // Open Modal
  async function openModal(handle) {
    if (!handle) return;

    // Reset state
    currentProduct = null;
    currentVariants = [];
    selectedColor = null;
    setDistribution = {};
    maxSets = 0;
    wholesaleProduct = null;
    retailProduct = null;
    hasRetailVersion = false;

    // ✅ KAT SAYI: Reset
    katSayi = 0;
    isKatSayiMode = false;
    selectedKatSayiSize = null;

    // Reset asorti state
    baseStokKodu = null;
    availableAsortis = [];
    currentAsortiKod = null;

    // Reset Cup state
    currentCupHane = null;
    cupBaseModel = null;
    availableCups = [];
    kzkAdimPaketleme = false;
    kzkAdimCup = false;
    cupOption = null;
    paketSecenekleri = [];
    secilenPaket = null;
    detailedSelectedCup = null;
    // URL'de cup secimi varsa 2. adim tamamlanmis sayilir (cup degistirince tasinir)
    try {
      const urlCup = new URLSearchParams(window.location.search).get('cup');
      if (urlCup) { kzkAdimCup = true; detailedSelectedCup = urlCup; }
    } catch (e) { /* parametre okunamazsa normal akis */ }

    // Determine handles
    if (handle.endsWith(RETAIL_SUFFIX)) {
      // Opened retail product
      retailHandle = handle;
      wholesaleHandle = handle.slice(0, -RETAIL_SUFFIX.length);
      isWholesale = false;
    } else {
      // Opened wholesale product
      wholesaleHandle = handle;
      retailHandle = handle + RETAIL_SUFFIX;
      isWholesale = true;

      // Parse handle for asorti info
      const asortiInfo = parseHandleForAsorti(handle);
      if (asortiInfo) {
        baseStokKodu = asortiInfo.stokkodu;
        currentAsortiKod = asortiInfo.asortiKod;
        log('Asorti info extracted:', asortiInfo);
      }

      // Cup info parse: barkod ilk 2 hane KZK_CUP_HANES'de mi?
      const cupInfo = parseHandleForCup(handle);
      if (cupInfo) {
        currentCupHane = cupInfo.hane;
        cupBaseModel = cupInfo.modelWithAsorti;
        log('Cup info extracted:', cupInfo);
      }
    }

    // Show modal with loading
    overlay.style.display = 'flex';
    setTimeout(() => overlay.classList.add('qv-active'), 10);

    loading.style.display = 'flex';
    productSection.style.display = 'none';

    // Hide mode toggle initially
    const modeToggle = overlay.querySelector('.qv-mode-toggle');
    if (modeToggle) modeToggle.style.display = 'none';

    try {
      // Fetch main product
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error('Product not found');

      currentProduct = await response.json();
      currentVariants = currentProduct.variants || [];

      // KZK model urun: 'Cup' secenegi varsa cup'lar ayni urunun icinde; handle tabanli cup/paket arama kapali.
      cupOption = findOptionByType(currentProduct.options, ['cup']) || null;
      paketSecenekleri = paketEtiketleriOku(currentProduct.tags);
      if (cupOption) {
        availableCups = getOptionValues(cupOption.position).map(v => ({ cup: v.value, deger: v.value, option: true }));
        cupBaseModel = null;
        currentCupHane = null;
        try {
          const urlCup = new URLSearchParams(window.location.search).get('cup');
          if (urlCup && availableCups.some(c => c.deger === urlCup)) { detailedSelectedCup = urlCup; kzkAdimCup = true; }
          else if (kzkAdimCup && !availableCups.some(c => c.deger === detailedSelectedCup)) { kzkAdimCup = false; detailedSelectedCup = null; }
        } catch (e) { /* parametre okunamazsa normal akis */ }
        log('Cup secenegi (model urun):', availableCups.map(c => c.cup), '| paket:', paketSecenekleri);
      }
      if (paketSecenekleri.length) kzkAdimPaketleme = true;

      // KZK: handle suffix kesin yontem - '-r' ile biten retail, digerleri toptan
      // Description-based detection KULLANILMAZ (eski upload'larda Set İçeriği yoksa
      // toptan urun retail'a duser, yanlis)
      // isWholesale openModal'da zaten handle suffix'e gore set edildi - korunur
      log('Wholesale (handle-based):', isWholesale, '| handle:', handle);

      // Store in appropriate variable
      if (isWholesale) {
        wholesaleProduct = currentProduct;
      } else {
        retailProduct = currentProduct;
      }

      log('Product loaded:', currentProduct.title, 'Wholesale:', isWholesale);

      // KZK: Retail urunler eklendi - quickview'da WS/RETAIL toggle aktif
      // Wholesale handle: '5070220000', retail handle: '5070220000-r'
      const RETAIL_ENABLED = true;

      if (RETAIL_ENABLED && isWholesale) {
        await checkRetailVersion();
      } else if (RETAIL_ENABLED && !isWholesale) {
        await checkWholesaleVersion();
      }

      // Asorti + Cup kontrolu (paralel, toptan icin)
      if (isWholesale) {
        const checks = [];
        if (baseStokKodu) checks.push(checkOtherAsortis());
        if (cupBaseModel && currentCupHane) checks.push(checkOtherCups());
        if (checks.length) await Promise.all(checks);
      }

      // Fetch inventory data
      await fetchInventoryData(handle);

      // Render product
      renderProduct();

      // Render asorti / cup selectors if multiple variants available
      if (availableAsortis.length > 1) {
        renderAsortiSelector();
      }
      if (availableCups.length > 1) {
        renderCupSelector();
      }

    } catch (error) {
      logError('Failed to load product:', error);
      showNotification(TRANSLATIONS.error || 'An error occurred', true);
      closeModal();
    }
  }

  // Check if retail version exists
  async function checkRetailVersion() {
    try {
      const response = await fetch(`/products/${retailHandle}.js`);
      if (response.ok) {
        retailProduct = await response.json();
        hasRetailVersion = true;
        log('✅ Retail version found:', retailHandle);

        // Show mode toggle
        const modeToggle = overlay.querySelector('.qv-mode-toggle');
        if (modeToggle) {
          modeToggle.style.display = 'flex';
          // Set active state
          overlay.querySelector('.qv-mode-wholesale').classList.add('active');
          overlay.querySelector('.qv-mode-retail').classList.remove('active');
        }
      } else {
        log('ℹ️ No retail version:', retailHandle);
      }
    } catch (e) {
      log('ℹ️ Retail version check failed:', e.message);
    }
  }

  // Check if wholesale version exists (when opening retail product)
  async function checkWholesaleVersion() {
    try {
      const response = await fetch(`/products/${wholesaleHandle}.js`);
      if (response.ok) {
        wholesaleProduct = await response.json();
        log('✅ Wholesale version found:', wholesaleHandle);

        // Show mode toggle
        const modeToggle = overlay.querySelector('.qv-mode-toggle');
        if (modeToggle) {
          modeToggle.style.display = 'flex';
          // Set active state - retail is active since we opened retail
          overlay.querySelector('.qv-mode-wholesale').classList.remove('active');
          overlay.querySelector('.qv-mode-retail').classList.add('active');
        }
      } else {
        log('ℹ️ No wholesale version:', wholesaleHandle);
        // No wholesale version - hide mode toggle, only retail available
        const modeToggle = overlay.querySelector('.qv-mode-toggle');
        if (modeToggle) {
          modeToggle.style.display = 'none';
        }
      }
    } catch (e) {
      log('ℹ️ Wholesale version check failed:', e.message);
    }
  }

  // Switch between wholesale and retail mode
  async function switchMode(mode) {
    if (mode === 'wholesale' && isWholesale) return;
    if (mode === 'retail' && !isWholesale) return;

    log('🔄 Switching to mode:', mode);

    const wholesaleBtn = overlay.querySelector('.qv-mode-wholesale');
    const retailBtn = overlay.querySelector('.qv-mode-retail');
    const infoSection = overlay.querySelector('.qv-info-section');
    const targetBtn = mode === 'wholesale' ? wholesaleBtn : retailBtn;

    // Add loading state
    targetBtn.classList.add('loading');
    infoSection.classList.add('loading');

    try {
      if (mode === 'wholesale') {
        wholesaleBtn.classList.add('active');
        retailBtn.classList.remove('active');
        isWholesale = true;
        currentProduct = wholesaleProduct;
        currentVariants = wholesaleProduct.variants || [];
        await fetchInventoryData(wholesaleHandle);
      } else {
        retailBtn.classList.add('active');
        wholesaleBtn.classList.remove('active');
        isWholesale = false;
        currentProduct = retailProduct;
        currentVariants = retailProduct.variants || [];
        await fetchInventoryData(retailHandle);
      }

      // Reset selections
      selectedColor = null;
      setDistribution = {};
      maxSets = 0;

      // Re-render product
      renderProduct();
    } finally {
      // Remove loading state
      targetBtn.classList.remove('loading');
      infoSection.classList.remove('loading');
    }
  }

  // ✅ Stok bilgisini ürün sayfasından çek
  async function fetchInventoryData(handle) {
    try {
      const response = await fetch(`/products/${handle}`);
      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // variant-options içindeki script[type="application/json"] bul
      const variantOptionsScript = doc.querySelector('variant-options script[type="application/json"]');
      if (variantOptionsScript) {
        try {
          const variantsData = JSON.parse(variantOptionsScript.textContent);
          if (Array.isArray(variantsData)) {
            variantsData.forEach(v => {
              const variant = currentVariants.find(cv => cv.id === v.id);
              if (variant) {
                variant.inventory_quantity = v.inventory_quantity || 0;
                log(`📦 Stok güncellendi: ${variant.title} = ${v.inventory_quantity}`);
              }
            });
            log(`✅ ${variantsData.length} varyant stok bilgisi güncellendi`);
            return;
          }
        } catch (e) {
          log('⚠️ variant-options JSON parse hatası:', e);
        }
      }

      // Fallback: window.productData kontrolü (group-pricing-data.liquid)
      const scripts = doc.querySelectorAll('script');
      for (const script of scripts) {
        const content = script.textContent || '';
        if (content.includes('window.productData') && content.includes('inventory_quantity')) {
          try {
            const match = content.match(/window\.productData\s*=\s*(\{[\s\S]*?\});/);
            if (match) {
              const productData = eval('(' + match[1] + ')');
              if (productData && productData.variants) {
                productData.variants.forEach(v => {
                  const variant = currentVariants.find(cv => cv.id === v.id);
                  if (variant) {
                    variant.inventory_quantity = v.inventory_quantity;
                    log(`📦 Stok güncellendi: ${variant.title} = ${v.inventory_quantity}`);
                  }
                });
                return;
              }
            }
          } catch (e) {
            log('⚠️ productData parse hatası:', e);
          }
        }
      }
    } catch (error) {
      log('⚠️ Stok bilgisi çekilemedi:', error);
    }
  }

  // Close Modal
  function closeModal() {
    // Inline mode'da kapanma yok - overlay sayfa icinde kalir
    if (__qvInlineActive) return;
    overlay.classList.remove('qv-active');
    setTimeout(() => {
      overlay.style.display = 'none';
      loading.style.display = 'flex';
      productSection.style.display = 'none';
    }, 300);
  }

  // Render Product
  function renderProduct() {
    if (!currentProduct) return;

    // Hide loading, show product
    loading.style.display = 'none';
    productSection.style.display = 'grid';

    // Basic info
    overlay.querySelector('.qv-title').textContent = currentProduct.title;
    overlay.querySelector('.qv-view-product').href = `/products/${currentProduct.handle}`;

    // Barcode (SKU)
    renderBarcode();

    // ✅ Determine customer group from tags
    determineCustomerGroup();

    // Image
    renderImages();

    // Colors
    renderColorSelector();

    // KZK: Paketleme alternatifi (Askili / Kutulu) async kontrol
    setupPackagingOptions();

    // ✅ Price (after group is determined)
    renderPrice();

    // Lot urunleri (beden bazli set dagilimi olanlar) matrix'e DEGIL set arayuzune gider:
    // matrix her bedene ayni adimi uygular, 1-2-2-1 gibi dagilimi ifade edemez.
    const lotDagilimi = parseSetIcerigiPairs(currentProduct && currentProduct.description);

    // İç giyim ürünleri: matrix UI DEFAULT aç (mode toggle/standart akis YOK).
    // Icgiyim seri olarak satilmaz; aciklamada eski "Set Icerigi" kalmis olsa bile matris acilir (12.09.2026).
    if (isUnderwearProduct()) {
      const modeToggle = overlay.querySelector('.qv-mode-toggle');
      if (modeToggle) modeToggle.style.display = 'none';
      const colorSelector = overlay.querySelector('.qv-color-selector');
      if (colorSelector) colorSelector.style.display = 'none';
      // Eski cup selector (renderCupSelector tarafindan eklenir) - matrix kendi cup'i var, gizle
      const oldCupSelector = overlay.querySelector('.qv-cup-selector');
      if (oldCupSelector) oldCupSelector.style.display = 'none';
      wholesaleSection.style.display = 'none';
      retailSection.style.display = 'none';
      overlay.querySelector('.qv-detailed-section').style.display = 'block';
      // İç giyim'de geri tusu lazim degil - tek mod
      const backBtn = overlay.querySelector('.qv-detailed-back-btn');
      if (backBtn) backBtn.style.display = 'none';
      // Detailed butonunu da gizle (zaten matrix'teyiz)
      const detailedOpenBtn = overlay.querySelector('.qv-detailed-open-btn');
      if (detailedOpenBtn) detailedOpenBtn.style.display = 'none';
      renderDetailedSection();
      return;
    }

    // Non-icgiyim: eski cup selector tekrar gorunsun (varsa)
    const oldCupSelector = overlay.querySelector('.qv-cup-selector');
    if (oldCupSelector) oldCupSelector.style.display = '';

    // KZK: Retail aktif - isWholesale (description: Set/Kat Sayı) ise wholesale, degilse retail
    if (isWholesale) {
      wholesaleSection.style.display = 'block';
      retailSection.style.display = 'none';
      overlay.querySelector('.qv-detailed-section').style.display = 'none';
      renderWholesaleSection();
    } else {
      wholesaleSection.style.display = 'none';
      retailSection.style.display = 'block';
      overlay.querySelector('.qv-detailed-section').style.display = 'none';
      renderRetailSection();
    }
    // Detayli buton ve back butonu yeniden gorunur olabilir (non-icgiyim akiste)
    const backBtn = overlay.querySelector('.qv-detailed-back-btn');
    if (backBtn) backBtn.style.display = '';
    showDetailedButton();
  }

  // ✅ Sayı çıkarma helper fonksiyonu
  function extractGroupNumber(text) {
    if (!text) return null;
    const match = text.match(/(\d+)/);
    return match ? match[1] : null;
  }

  // ✅ Determine customer group based on tags
  function determineCustomerGroup() {
    // ✅ Önce QuickviewConfig'den müşteri grubunu al (Liquid'de hesaplandı - group-pricing ile aynı mantık)
    const configCustomerGroup = window.QuickviewConfig?.customerGroup;

    // ✅ Grup option'unu bul
    const groupOption = findOptionByType(currentProduct.options, ['fiyat grubu', 'fiyat', 'grup', 'group', 'price', 'pricing']);

    if (!groupOption) {
      log('No group option found in product options:', currentProduct.options);
      selectedGroup = null;
      return;
    }

    // Get all group values from product variants
    const groupValues = getOptionValues(groupOption.position);
    log('🔍 Available groups:', groupValues.map(g => g.value));
    log('🔍 Customer group from config:', configCustomerGroup);
    log('🔍 Customer tags:', customerTags);

    // ✅ Öncelik 1: QuickviewConfig.customerGroup kullan (Liquid'de hesaplandı)
    if (configCustomerGroup) {
      const configGroupLower = configCustomerGroup.toLowerCase().trim();
      const cleanConfigGroup = configGroupLower.replace(/[.\s-]+/g, '');
      const configGroupNumber = extractGroupNumber(configCustomerGroup);

      log('🔍 Config group number:', configGroupNumber);

      for (const groupData of groupValues) {
        const groupLower = groupData.value.toLowerCase().trim();
        const cleanGroup = groupLower.replace(/[.\s-]+/g, '');
        const groupNumber = extractGroupNumber(groupData.value);

        // ✅ Sayı bazlı eşleştirme (en güvenilir)
        if (configGroupNumber && groupNumber && configGroupNumber === groupNumber) {
          selectedGroup = groupData.value;
          log('✅ Matched group by NUMBER:', selectedGroup, '(number:', configGroupNumber, ')');
          return;
        }

        // String eşleştirme
        if (configGroupLower === groupLower || cleanConfigGroup === cleanGroup) {
          selectedGroup = groupData.value;
          log('✅ Matched group from config:', selectedGroup);
          return;
        }
      }
    }

    // ✅ Öncelik 2: Customer tags ile eşleştir (fallback)
    if (customerTags.length > 0) {
      for (const tag of customerTags) {
        const tagLower = tag.toLowerCase().trim();

        // Sadece grup içeren tag'leri kontrol et
        if (!tagLower.includes('grup') && !tagLower.includes('group')) continue;

        const tagNumber = extractGroupNumber(tag);
        log('🔍 Checking tag:', tag, 'number:', tagNumber);

        for (const groupData of groupValues) {
          const groupNumber = extractGroupNumber(groupData.value);

          // ✅ Sayı bazlı eşleştirme
          if (tagNumber && groupNumber && tagNumber === groupNumber) {
            selectedGroup = groupData.value;
            log('✅ Matched group from tag by NUMBER:', selectedGroup, 'tag:', tag);
            return;
          }
        }
      }
    }

    // No match - use first available group
    if (groupValues.length > 0) {
      selectedGroup = groupValues[0].value;
      log('⚠️ No match - using default group:', selectedGroup);
    }
  }

  // ✅ Render Price - Grup fiyatlandırmasıyla
  function renderPrice() {
    const priceContainer = overlay.querySelector('.qv-price');

    // Get first variant matching selected group (if any) and color
    const variant = getFirstMatchingVariant();

    if (!variant) {
      priceContainer.innerHTML = '';
      return;
    }

    const price = formatMoney(variant.price);
    const comparePrice = variant.compare_at_price;

    if (comparePrice && comparePrice > variant.price) {
      priceContainer.innerHTML = `${price} <span class="qv-compare-price">${formatMoney(comparePrice)}</span>`;
    } else {
      priceContainer.innerHTML = price;
    }
  }

  // Render Barcode (from product handle)
  function renderBarcode() {
    const barcodeContainer = overlay.querySelector('.qv-barcode-value');
    if (!barcodeContainer) return;

    // Use product handle as barcode, remove -r suffix if present
    let barcode = currentProduct?.handle || null;

    if (barcode && barcode.endsWith(RETAIL_SUFFIX)) {
      barcode = barcode.slice(0, -RETAIL_SUFFIX.length);
    }

    if (barcode) {
      barcodeContainer.textContent = barcode;
      overlay.querySelector('.qv-barcode').style.display = 'block';
    } else {
      overlay.querySelector('.qv-barcode').style.display = 'none';
    }
  }

  // ✅ Get first variant matching group and color
  function getFirstMatchingVariant() {
    const groupOption = findOptionByType(currentProduct.options, ['fiyat grubu', 'fiyat', 'grup', 'group', 'price', 'pricing']);
    const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);

    for (const variant of currentVariants) {
      let match = true;

      // Match group
      if (groupOption && selectedGroup) {
        const variantGroup = variant[`option${groupOption.position}`];
        if (variantGroup !== selectedGroup) {
          match = false;
        }
      }

      // Match color
      if (colorOption && selectedColor) {
        const variantColor = variant[`option${colorOption.position}`];
        if (variantColor !== selectedColor) {
          match = false;
        }
      }

      if (match) return variant;
    }

    return currentVariants[0];
  }

  // Render Images
  function renderImages() {
    const mainImg = overlay.querySelector('.qv-main-image');
    const thumbsContainer = overlay.querySelector('.qv-image-thumbnails');

    if (currentProduct.images && currentProduct.images.length > 0) {
      mainImg.src = currentProduct.images[0];
      mainImg.alt = currentProduct.title;

      // Thumbnails
      thumbsContainer.innerHTML = '';
      currentProduct.images.slice(0, 5).forEach((img, index) => {
        const thumb = document.createElement('img');
        thumb.src = img.replace(/(\.[^.]+)$/, '_100x100$1');
        thumb.className = 'qv-thumb' + (index === 0 ? ' qv-thumb-active' : '');
        thumb.addEventListener('click', () => {
          mainImg.src = img;
          thumbsContainer.querySelectorAll('.qv-thumb').forEach(t => t.classList.remove('qv-thumb-active'));
          thumb.classList.add('qv-thumb-active');
        });
        thumbsContainer.appendChild(thumb);
      });
    } else {
      mainImg.src = '';
      thumbsContainer.innerHTML = '';
    }
  }

  // Render Color Selector
  function renderColorSelector() {
    const colorSection = overlay.querySelector('.qv-color-selector');
    const colorOptions = overlay.querySelector('.qv-color-options');

    // Find color option
    const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);

    if (!colorOption) {
      colorSection.style.display = 'none';
      selectedColor = null;
      return;
    }

    colorSection.style.display = 'block';
    colorOptions.innerHTML = '';

    const colorValues = getOptionValues(colorOption.position);
    const firstAvailableColor = colorValues.find(c => c.available) || colorValues[0];
    selectedColor = firstAvailableColor?.value || colorValues[0]?.value;

    colorValues.forEach(colorData => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qv-color-btn';
      btn.textContent = colorData.value;
      btn.dataset.color = colorData.value;

      if (!colorData.available) {
        btn.classList.add('qv-color-unavailable');
      }

      if (colorData.value === selectedColor) {
        btn.classList.add('qv-color-active');
      }

      btn.addEventListener('click', () => {
        if (!colorData.available) return;

        selectedColor = colorData.value;
        colorOptions.querySelectorAll('.qv-color-btn').forEach(b => b.classList.remove('qv-color-active'));
        btn.classList.add('qv-color-active');

        // Update image if variant has image
        updateImageByColor(colorData.value);

        // Re-render sections - moda gore
        if (isWholesale) renderWholesaleSection();
        else renderRetailSection();
      });

      colorOptions.appendChild(btn);
    });
  }

  // Update image by color
  function updateImageByColor(color) {
    const variant = currentVariants.find(v => {
      const colorPos = findOptionByType(currentProduct.options, ['color', 'colour', 'renk'])?.position;
      if (!colorPos) return false;
      return v[`option${colorPos}`] === color;
    });

    if (variant && variant.featured_image) {
      overlay.querySelector('.qv-main-image').src = variant.featured_image.src;
    }
  }

  // Find option by type - hem string hem object array destekler
  function findOptionByType(options, types) {
    if (!options || !Array.isArray(options)) return null;

    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      if (!opt) continue;

      // ✅ Hem string hem object formatını destekle
      let optName = '';
      if (typeof opt === 'string') {
        optName = opt.toLowerCase();
      } else if (typeof opt === 'object' && opt.name) {
        optName = opt.name.toLowerCase();
      } else {
        continue;
      }

      if (types.some(t => optName.includes(t))) {
        return { name: optName, position: i + 1 };
      }
    }
    return null;
  }

  // Get option values with availability
  function bedenleriSirala(list) {
    const sayisal = list.length > 1 && list.every(s => /^\d+(\.\d+)?$/.test(String(s.value).trim()));
    return sayisal ? list.slice().sort((a, b) => parseFloat(a.value) - parseFloat(b.value)) : list;
  }

  function getOptionValues(position) {
    const values = new Map();

    currentVariants.forEach(v => {
      const val = v[`option${position}`];
      if (val && !values.has(val)) {
        values.set(val, {
          value: val,
          available: false,
          variants: []
        });
      }
      if (val) {
        const data = values.get(val);
        data.variants.push(v);
        if (v.available) data.available = true;
      }
    });

    return Array.from(values.values());
  }

  // =====================
  // WHOLESALE FUNCTIONS
  // =====================

  function renderWholesaleSection() {
    // ✅ KAT SAYI: Önce Kat Sayı modunu kontrol et
    katSayi = detectKatSayi(currentProduct.description);
    isKatSayiMode = katSayi > 0;

    if (isKatSayiMode) {
      log('Kat Sayı modu aktif:', katSayi);
      renderKatSayiSection();
      return;
    }

    // Set modu: varsayilan labellar
    setKatSayiLabels(false);

    // Parse set distribution from description
    // Once 'beden=adet|beden=adet' bicimi (sayisal bedenlerde eski parser calismiyor),
    // eslesmezse eski cok bicimli parser.
    setDistribution = parseSetIcerigiPairs(currentProduct.description)
      || parseSetDistribution(currentProduct.description);

    // Urunun GERCEK bedenlerini variants'tan al (option-values'dan DEGIL).
    // Shopify'da bazen option_value listesinde XXL gibi degerler kalir ama
    // o bedenden variant yaratilmamistir - Set İçeriği'ne yanlis bedenler girer.
    const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
    const productSizes = [];
    if (sizeOption) {
      const seen = new Set();
      (currentProduct.variants || []).forEach(v => {
        const sz = v[`option${sizeOption.position}`];
        if (sz && !seen.has(sz)) { seen.add(sz); productSizes.push(String(sz).trim()); }
      });
    }

    if (Object.keys(setDistribution).length === 0) {
      // Auto-generate distribution (1 of each size)
      productSizes.forEach(sz => {
        setDistribution[sz] = 1;
      });
    } else if (productSizes.length) {
      // Description'daki Set İçeriği bedenlerini urunun gercek bedenleriyle filtrele
      // (CSV uretiminde bazen Shopify'a yuklenmemis bedenler Set İçeriği'ne girebiliyor)
      const productSizesUpper = new Set(productSizes.map(s => s.toUpperCase()));
      const filtered = {};
      const removed = [];
      Object.entries(setDistribution).forEach(([size, qty]) => {
        if (productSizesUpper.has(String(size).toUpperCase())) {
          filtered[size] = qty;
        } else {
          removed.push(size);
        }
      });
      if (removed.length) {
        log("Set Iceriği'nden urun varyantinda olmayan bedenler cikarildi:", removed);
      }
      setDistribution = Object.keys(filtered).length ? filtered : setDistribution;
    }

    log('Set distribution:', setDistribution);

    // Render set info - compact single line format (kucukten buyuge sirali)
    const distContainer = overlay.querySelector('.qv-set-distribution');
    let totalPerSet = 0;
    const SIZE_ORDER = ['XXS','XS','S','M','L','XL','XXL','2XL','3XL','4XL','5XL','6XL'];
    function sizeRank(s) {
      const up = String(s).toUpperCase().trim();
      const idx = SIZE_ORDER.indexOf(up);
      if (idx !== -1) return idx;
      // Sayisal beden (80, 85, 90...): numerik karsilastirma
      const num = parseFloat(up);
      if (!isNaN(num)) return 1000 + num;
      return 99999;  // bilinmeyen sona
    }
    const sortedEntries = Object.entries(setDistribution)
      .sort((a, b) => sizeRank(a[0]) - sizeRank(b[0]));
    const parts = [];
    sortedEntries.forEach(([size, qty]) => {
      totalPerSet += qty;
      parts.push(`${size}×${qty}`);
    });
    distContainer.textContent = parts.join(' / ');

    // Render size stock table
    renderSizeStockTable();

    // Calculate max sets based on stock
    maxSets = calculateMaxSets();

    overlay.querySelector('.qv-max-sets-value').textContent = `${maxSets} set`;

    // Update quantity input
    const qtyInput = wholesaleSection.querySelector('.qv-qty-input');
    qtyInput.value = 1;
    qtyInput.max = maxSets;

    // Update total
    updateWholesaleTotal();

    // Enable/disable buttons
    const addBtn = overlay.querySelector('.qv-add-wholesale');
    addBtn.disabled = maxSets === 0;
  }

  // Render Size Stock Table for Wholesale
  function renderSizeStockTable() {
    const tableContainer = overlay.querySelector('.qv-size-stock-table');
    if (!tableContainer) return;

    tableContainer.innerHTML = '';

    const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
    const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);

    if (!sizeOption) return;

    let totalStock = 0;
    const sizes = Object.keys(setDistribution);

    sizes.forEach(size => {
      // Find variant for this size + selected color
      const variant = currentVariants.find(v => {
        let match = true;

        if (sizeOption) {
          const variantSize = v[`option${sizeOption.position}`];
          match = match && (variantSize === size || matchSizeRange(variantSize, size));
        }

        if (colorOption && selectedColor) {
          const variantColor = v[`option${colorOption.position}`];
          match = match && variantColor === selectedColor;
        }

        return match;
      });

      const stock = variant ? getVariantStock(variant) : 0;
      const realStock = stock === 999 ? '∞' : stock;
      totalStock += (stock === 999 ? 0 : stock);

      let stockClass = '';
      if (stock === 0) stockClass = 'out';
      else if (stock <= 5 && stock !== 999) stockClass = 'low';

      const row = document.createElement('div');
      row.className = 'qv-size-stock-row';
      row.innerHTML = `
        <span class="size-label">${size}</span>
        <span class="size-stock ${stockClass}">${realStock} adet</span>
      `;
      tableContainer.appendChild(row);
    });

    // Total stock row
    const totalRow = document.createElement('div');
    totalRow.className = 'qv-total-stock';
    totalRow.innerHTML = `
      <span>Toplam Stok:</span>
      <span>${totalStock} adet</span>
    `;
    tableContainer.appendChild(totalRow);
  }

  // ✅ Stok değerini al - inventory_quantity yoksa available field'ına bak
  function getVariantStock(variant) {
    // inventory_quantity varsa onu kullan
    if (typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0) {
      return variant.inventory_quantity;
    }
    // Yoksa available field'ına bak - available ise yüksek stok varsay
    if (variant.available) {
      return 999; // Yüksek varsayılan değer
    }
    return 0;
  }

  // ✅ Calculate max sets - Tüm grupların stoğu aynı, grup filtresi olmadan hesapla
  function calculateMaxSets() {
    const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
    const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);

    let minStock = Infinity;
    let allAvailable = true;

    log('📦 Calculating max sets for distribution:', setDistribution);
    log('📦 Selected color:', selectedColor);

    Object.entries(setDistribution).forEach(([size, requiredQty]) => {
      // ✅ Stok hesabı için grup filtresi YOK - tüm grupların stoğu aynı
      // Sadece beden ve renk eşleşmesi yap
      const variant = currentVariants.find(v => {
        let match = true;

        // Match size
        if (sizeOption) {
          const variantSize = v[`option${sizeOption.position}`];
          match = match && (variantSize === size || matchSizeRange(variantSize, size));
        }

        // Match color (eğer seçiliyse)
        if (colorOption && selectedColor) {
          const variantColor = v[`option${colorOption.position}`];
          match = match && variantColor === selectedColor;
        }

        return match;
      });

      if (variant) {
        const stock = getVariantStock(variant);
        const possibleSets = Math.floor(stock / requiredQty);
        minStock = Math.min(minStock, possibleSets);

        if (!variant.available) {
          allAvailable = false;
        }

        log(`📦 Size ${size}: stock=${stock}, available=${variant.available}, required=${requiredQty}, possible=${possibleSets} sets`);
      } else {
        log(`⚠️ Variant not found for size: ${size}, color: ${selectedColor}`);
        // Renk seçili değilse, sadece beden ile dene
        if (selectedColor) {
          const variantWithoutColor = currentVariants.find(v => {
            if (!sizeOption) return false;
            const variantSize = v[`option${sizeOption.position}`];
            return variantSize === size || matchSizeRange(variantSize, size);
          });
          if (variantWithoutColor) {
            const stock = getVariantStock(variantWithoutColor);
            const possibleSets = Math.floor(stock / requiredQty);
            minStock = Math.min(minStock, possibleSets);
            log(`📦 Size ${size} (any color): stock=${stock}, possible=${possibleSets} sets`);
          } else {
            allAvailable = false;
            minStock = 0;
          }
        } else {
          allAvailable = false;
          minStock = 0;
        }
      }
    });

    // Eğer tüm bedenler available ise ve minStock hala 999 ise, makul bir değer kullan
    if (minStock === 999) {
      minStock = 99; // Makul bir maksimum
    }

    log('📦 Final max sets:', minStock === Infinity ? 0 : minStock, 'allAvailable:', allAvailable);
    return minStock === Infinity ? 0 : minStock;
  }

  // Match size range (e.g., "7-8" matches variant "7-8")
  // ✅ FIX: Standart bedenler için sadece exact match, numeric range için partial match
  function matchSizeRange(variantSize, distributionSize) {
    if (!variantSize || !distributionSize) return false;

    const vs = String(variantSize).toUpperCase().trim();
    const ds = String(distributionSize).toUpperCase().trim();

    // ✅ Exact match - her zaman ilk kontrol
    if (vs === ds) return true;

    // ✅ Numeric range matching (örn: "7-8", "9-10") - sadece her ikisi de range ise
    const isVsRange = /^\d+-\d+$/.test(vs);
    const isDsRange = /^\d+-\d+$/.test(ds);
    if (isVsRange && isDsRange) {
      return vs.includes(ds) || ds.includes(vs);
    }

    // ✅ Standart bedenler için SADECE exact match
    // L ve XL karışmasın diye includes kullanma!
    return false;
  }

  function updateSetQuantity(delta) {
    const input = wholesaleSection.querySelector('.qv-qty-input');
    const currentVal = parseInt(input.value) || 1;
    const newVal = Math.max(1, Math.min(maxSets, currentVal + delta));
    input.value = newVal;
    updateWholesaleTotal();
  }

  function setSetQuantity(val) {
    const input = wholesaleSection.querySelector('.qv-qty-input');
    const newVal = Math.max(1, Math.min(maxSets, val));
    input.value = newVal;
    updateWholesaleTotal();
  }

  function updateWholesaleTotal() {
    const qty = parseInt(wholesaleSection.querySelector('.qv-qty-input').value) || 1;
    let totalItems = 0;
    Object.values(setDistribution).forEach(q => totalItems += q);
    totalItems *= qty;

    overlay.querySelector('.qv-total-items').textContent = `${totalItems} adet (${qty} set)`;
  }

  // ✅ Add wholesale to cart - items array kullanarak doğrudan ekle (quantity-multiplier bypass)
  async function addWholesaleToCart() {
    // ✅ KAT SAYI: Kat Sayı modunda farklı işlem
    if (isKatSayiMode) {
      return addKatSayiToCart();
    }

    const btn = overlay.querySelector('.qv-add-wholesale');
    const sets = parseInt(wholesaleSection.querySelector('.qv-qty-input').value) || 1;

    btn.classList.add('qv-loading-btn');
    btn.disabled = true;

    try {
      const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
      const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);
      const groupOption = findOptionByType(currentProduct.options, ['fiyat grubu', 'fiyat', 'grup', 'group', 'price', 'pricing']);

      console.log('🛒 ========== SEPETE EKLEME (items array - quantity-multiplier bypass) ==========');
      console.log('🛒 Selected Group:', selectedGroup);
      console.log('🛒 Selected Color:', selectedColor);
      console.log('🛒 Sets:', sets);
      console.log('🛒 Set Distribution:', setDistribution);
      console.log('🛒 Current Product Handle:', currentProduct.handle);
      console.log('🛒 Current Asorti:', currentAsortiKod || 'N/A');

      // ✅ Her beden için items array oluştur
      const items = [];
      let totalAdded = 0;

      for (const [size, qtyPerSet] of Object.entries(setDistribution)) {
        const totalQty = qtyPerSet * sets;
        if (totalQty <= 0) continue;

        // Bu beden + grup + renk için varyantı bul
        const variant = currentVariants.find(v => {
          let match = true;

          // Match size
          if (sizeOption) {
            const vSize = v[`option${sizeOption.position}`];
            if (vSize !== size) match = false;
          }

          // Match group
          if (groupOption && selectedGroup) {
            const vGroup = v[`option${groupOption.position}`];
            if (vGroup !== selectedGroup) match = false;
          }

          // Match color
          if (colorOption && selectedColor) {
            const vColor = v[`option${colorOption.position}`];
            if (vColor !== selectedColor) match = false;
          }

          return match && v.available;
        });

        if (variant) {
          items.push({
            id: variant.id,
            quantity: totalQty
          });
          totalAdded += totalQty;
          console.log(`🛒 Size ${size}: Variant ${variant.id} (${variant.title}) x ${totalQty}`);
        } else {
          console.warn(`🛒 ⚠️ Size ${size}: No variant found for group=${selectedGroup}, color=${selectedColor}`);
        }
      }

      if (items.length === 0) {
        throw new Error('No available variants found for selected group/color');
      }

      console.log('🛒 Total items to add:', items.length);
      console.log('🛒 Total quantity:', totalAdded);

      // ✅ items array formatı kullan - quantity-multiplier bunu bypass edecek
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        // Shopify 422'de istenenin bir kismini yine de ekleyebiliyor: gercek mesaji goster, sepeti yenile
        const hata = await response.json().catch(() => ({}));
        refreshCart();
        const mesaj = hata.description || hata.message || TRANSLATIONS.error || 'An error occurred';
        showNotification(`${mesaj} Lütfen sepetinizi kontrol edin.`, true);
        return;
      }

      showNotification(`${totalAdded} adet (${sets} set) sepete eklendi!`);

      // Refresh cart
      refreshCart();

      // ✅ Modal açık kalsın - kullanıcı isterse kendisi kapatsın
      // setTimeout(closeModal, 1500);

    } catch (error) {
      logError('Add to cart error:', error);
      showNotification(TRANSLATIONS.error || 'An error occurred', true);
    } finally {
      btn.classList.remove('qv-loading-btn');
      btn.disabled = maxSets === 0;
    }
  }

  // =====================
  // KAT SAYI FUNCTIONS (İç Giyim)
  // =====================

  // ✅ KAT SAYI: Modal labellerini Kat Sayı moduna gore guncelle
  function setKatSayiLabels(isKatSayi) {
    const wsec = overlay.querySelector('.qv-wholesale-section');
    if (!wsec) return;

    const labelMap = isKatSayi
      ? {
          set: 'Paket Bilgisi:',
          maxSets: 'Maksimum eklenebilir:',
          setQty: 'Paket Adedi:',
          addBtn: 'PAKET OLARAK EKLE'
        }
      : {
          set: 'Set İçeriği:',
          maxSets: 'Maksimum eklenebilir:',
          setQty: 'Set Adedi:',
          addBtn: 'SET OLARAK EKLE'
        };

    const setInfoLbl = wsec.querySelector('.qv-set-info .qv-label');
    if (setInfoLbl) setInfoLbl.textContent = labelMap.set;

    const maxLbl = wsec.querySelector('.qv-max-sets-label');
    if (maxLbl) maxLbl.textContent = labelMap.maxSets;

    const setQtyLbl = wsec.querySelector('.qv-set-quantity .qv-label');
    if (setQtyLbl) setQtyLbl.textContent = labelMap.setQty;

    const addBtn = wsec.querySelector('.qv-add-wholesale');
    if (addBtn) addBtn.textContent = labelMap.addBtn;
  }

  // ✅ KAT SAYI: İç giyim ürünleri için özel section render
  function renderKatSayiSection() {
    const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
    const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);

    // Kat Sayı modunda labelleri guncelle (varsayilan "Set" labelleri yaniltici)
    setKatSayiLabels(true);

    // Kat Sayı bilgisini göster (set distribution yerine)
    const distContainer = overlay.querySelector('.qv-set-distribution');
    distContainer.innerHTML = `<span style="color: #667eea; font-weight: 600;">${katSayi}'er adet paket</span>`;

    // Size stock table - Kat Sayı modunda her beden ayrı gösterilir
    renderKatSayiSizeTable();

    // Max quantity hesapla (stok bazlı)
    const maxQty = calculateKatSayiMaxQuantity();
    maxSets = Math.floor(maxQty / katSayi); // Kaç kat eklenebilir

    overlay.querySelector('.qv-max-sets-value').textContent = `${maxSets} kat (${maxQty} adet)`;

    // Quantity input - artik KAT sayisi (1,2,3...). Pieces = value * katSayi.
    const qtyInput = wholesaleSection.querySelector('.qv-qty-input');
    qtyInput.value = 1;
    qtyInput.min = 1;
    qtyInput.step = 1;
    qtyInput.max = Math.max(1, maxSets);

    // Total güncelle
    updateKatSayiTotal();

    // Butonları Kat Sayı moduna göre ayarla
    setupKatSayiQuantityControls();

    // Enable/disable add button
    const addBtn = overlay.querySelector('.qv-add-wholesale');
    addBtn.disabled = maxQty === 0;
  }

  // ✅ KAT SAYI: Size stock table render (tıklanabilir beden seçimi)
  function renderKatSayiSizeTable() {
    const tableContainer = overlay.querySelector('.qv-size-stock-table');
    if (!tableContainer) return;

    tableContainer.innerHTML = '';

    const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
    const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);

    if (!sizeOption) return;

    const sizes = bedenleriSirala(getOptionValues(sizeOption.position));
    let totalStock = 0;
    let firstAvailableSize = null;

    sizes.forEach(sizeData => {
      // Find variant for this size + selected color
      const variant = currentVariants.find(v => {
        let match = v[`option${sizeOption.position}`] === sizeData.value;

        if (colorOption && selectedColor) {
          match = match && v[`option${colorOption.position}`] === selectedColor;
        }

        return match;
      });

      const stock = variant ? getVariantStock(variant) : 0;
      const realStock = stock === 999 ? '∞' : stock;
      totalStock += (stock === 999 ? 0 : stock);

      // İlk available size'ı kaydet
      if (!firstAvailableSize && stock > 0) {
        firstAvailableSize = sizeData.value;
      }

      let stockClass = '';
      if (stock === 0) stockClass = 'out';
      else if (stock <= 5 && stock !== 999) stockClass = 'low';

      const isSelected = selectedKatSayiSize === sizeData.value;
      const isAvailable = stock > 0;

      const row = document.createElement('div');
      row.className = `qv-size-stock-row qv-kat-sayi-size ${isSelected ? 'selected' : ''} ${!isAvailable ? 'disabled' : ''}`;
      row.dataset.size = sizeData.value;
      row.dataset.variantId = variant ? variant.id : '';
      row.dataset.stock = stock;
      row.style.cssText = `
        cursor: ${isAvailable ? 'pointer' : 'not-allowed'};
        padding: 8px 12px;
        border-radius: 6px;
        margin-bottom: 4px;
        transition: all 0.2s ease;
        ${isSelected ? 'background: #000; color: #fff;' : 'background: #f5f5f5; color: #333;'}
        ${!isAvailable ? 'opacity: 0.5;' : ''}
      `;
      row.innerHTML = `
        <span class="size-label" style="font-weight: ${isSelected ? '600' : '400'};">${sizeData.value}</span>
        <span class="size-stock ${stockClass}">${realStock} adet</span>
      `;

      // Tıklama event'i
      if (isAvailable) {
        row.addEventListener('click', () => {
          selectedKatSayiSize = sizeData.value;
          log('Kat Sayı beden seçildi:', selectedKatSayiSize);
          renderKatSayiSizeTable(); // Tabloyu yeniden render et
          updateKatSayiQuantityLimits(); // Miktar limitlerini güncelle
        });
      }

      tableContainer.appendChild(row);
    });

    // Eğer hiç beden seçili değilse, ilk available bedeni seç
    if (!selectedKatSayiSize && firstAvailableSize) {
      selectedKatSayiSize = firstAvailableSize;
      renderKatSayiSizeTable(); // Tekrar render et
      return;
    }

    // Total stock row
    const totalRow = document.createElement('div');
    totalRow.className = 'qv-total-stock';
    totalRow.style.cssText = 'margin-top: 8px; padding-top: 8px; border-top: 1px solid #ddd;';
    totalRow.innerHTML = `
      <span>Toplam Stok:</span>
      <span>${totalStock} adet</span>
    `;
    tableContainer.appendChild(totalRow);
  }

  // ✅ KAT SAYI: Miktar limitlerini güncelle (beden seçimi sonrası)
  function updateKatSayiQuantityLimits() {
    const maxQty = calculateKatSayiMaxQuantity();
    maxSets = Math.floor(maxQty / katSayi);

    const maxSetsEl = overlay.querySelector('.qv-max-sets-value');
    if (maxSetsEl) {
      maxSetsEl.textContent = `${maxQty} adet (${maxSets} kat)`;
    }

    const container = wholesaleSection.querySelector('.qv-quantity-controls');
    if (container) {
      const input = container.querySelector('.qv-qty-input');
      if (input) {
        input.max = maxQty;

        // Eğer mevcut miktar max'ı aşıyorsa, düzelt
        const currentQty = parseInt(input.value) || katSayi;
        if (currentQty > maxQty) {
          input.value = maxQty > 0 ? maxQty : katSayi;
        }
      }
    }

    updateKatSayiTotal();

    // Add button durumunu güncelle
    const addBtn = overlay.querySelector('.qv-add-wholesale');
    if (addBtn) {
      addBtn.disabled = maxQty === 0;
    }
  }

  // ✅ KAT SAYI: Maksimum eklenebilir miktar hesapla (seçilen bedene göre)
  function calculateKatSayiMaxQuantity() {
    const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
    const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);

    let variant = null;

    // Seçili beden için variant bul
    if (sizeOption && selectedKatSayiSize) {
      variant = currentVariants.find(v => {
        let match = v[`option${sizeOption.position}`] === selectedKatSayiSize;

        if (colorOption && selectedColor) {
          match = match && v[`option${colorOption.position}`] === selectedColor;
        }

        return match;
      });
    }

    // Eğer beden seçili değilse veya variant bulunamadıysa, ilk available variant'ı kullan
    if (!variant) {
      variant = currentVariants.find(v => {
        let match = v.available;
        if (colorOption && selectedColor) {
          match = match && v[`option${colorOption.position}`] === selectedColor;
        }
        return match;
      });
    }

    if (!variant) return 0;

    const stock = getVariantStock(variant);
    if (stock === 999) return 99 * katSayi; // Sonsuz stok varsa makul maksimum

    // Stoku Kat Sayı'nın katına yuvarla (aşağı)
    return Math.floor(stock / katSayi) * katSayi;
  }

  // ✅ KAT SAYI: Quantity kontrollerini ayarla
  function setupKatSayiQuantityControls() {
    const container = wholesaleSection.querySelector('.qv-quantity-controls');
    if (!container) return;

    // Önce input'u klonla ve değiştir
    const oldInput = container.querySelector('.qv-qty-input');
    const newInput = oldInput.cloneNode(true);
    oldInput.parentNode.replaceChild(newInput, oldInput);

    // Input degeri artik KAT sayisi (1,2,3...). Pieces = val * katSayi.
    newInput.addEventListener('change', (e) => {
      let kat = parseInt(e.target.value) || 1;
      const maxKat = Math.max(1, Math.floor(calculateKatSayiMaxQuantity() / katSayi));
      kat = Math.max(1, Math.min(maxKat, kat));
      e.target.value = kat;
      updateKatSayiTotal();
    });

    // Butonları klonla ve değiştir
    const oldMinusBtn = container.querySelector('.qv-qty-minus');
    const oldPlusBtn = container.querySelector('.qv-qty-plus');

    const newMinusBtn = oldMinusBtn.cloneNode(true);
    const newPlusBtn = oldPlusBtn.cloneNode(true);

    oldMinusBtn.parentNode.replaceChild(newMinusBtn, oldMinusBtn);
    oldPlusBtn.parentNode.replaceChild(newPlusBtn, oldPlusBtn);

    // Buton event'leri - input artik kat sayisi (1 step)
    newMinusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const input = container.querySelector('.qv-qty-input');
      const current = parseInt(input.value) || 1;
      input.value = Math.max(1, current - 1);
      updateKatSayiTotal();
    });

    newPlusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const input = container.querySelector('.qv-qty-input');
      const current = parseInt(input.value) || 1;
      const maxKat = Math.max(1, Math.floor(calculateKatSayiMaxQuantity() / katSayi));
      input.value = Math.min(maxKat, current + 1);
      updateKatSayiTotal();
    });

    log('Kat Sayı quantity controls setup complete');
  }

  // ✅ KAT SAYI: Total güncelle (input = kat sayisi, pieces = kat * katSayi)
  function updateKatSayiTotal() {
    const container = wholesaleSection.querySelector('.qv-quantity-controls');
    if (!container) return;

    const input = container.querySelector('.qv-qty-input');
    const katCount = parseInt(input.value) || 1;
    const pieces = katCount * katSayi;

    const totalEl = overlay.querySelector('.qv-total-items');
    if (totalEl) {
      totalEl.textContent = `${pieces} adet (${katCount} kat)`;
    }
  }

  // ✅ KAT SAYI: Sepete ekleme (seçilen beden, çoklu miktar)
  async function addKatSayiToCart() {
    const btn = overlay.querySelector('.qv-add-wholesale');
    const container = wholesaleSection.querySelector('.qv-quantity-controls');
    const input = container ? container.querySelector('.qv-qty-input') : null;
    // Input artik KAT cinsinden (1,2,3...) - pieces = kat * katSayi
    const katCountInput = input ? (parseInt(input.value) || 1) : 1;
    let quantity = Math.max(1, katCountInput) * katSayi;

    // Beden seçili olmalı
    if (!selectedKatSayiSize) {
      showNotification('Lütfen bir beden seçin!', true);
      return;
    }

    btn.classList.add('qv-loading-btn');
    btn.disabled = true;

    try {
      const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
      const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);

      console.log('🛒 ========== KAT SAYI SEPETE EKLEME ==========');
      console.log('🛒 Kat Sayı:', katSayi);
      console.log('🛒 Quantity:', quantity);
      console.log('🛒 Selected Color:', selectedColor);
      console.log('🛒 Selected Size:', selectedKatSayiSize);

      // Seçilen beden + renk için variant bul
      let variant = currentVariants.find(v => {
        let match = true;

        // Beden eşleşmesi
        if (sizeOption && selectedKatSayiSize) {
          match = match && v[`option${sizeOption.position}`] === selectedKatSayiSize;
        }

        // Renk eşleşmesi
        if (colorOption && selectedColor) {
          match = match && v[`option${colorOption.position}`] === selectedColor;
        }

        return match && v.available;
      });

      if (!variant) {
        throw new Error('Seçilen beden için uygun varyant bulunamadı');
      }

      console.log('🛒 Selected Variant:', variant.id, variant.title);

      // Sepete ekle
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: quantity
          }]
        })
      });

      if (!response.ok) throw new Error('Add to cart failed');

      const katCount = Math.floor(quantity / katSayi);
      showNotification(`${selectedKatSayiSize} - ${quantity} adet (${katCount} kat) sepete eklendi!`);

      refreshCart();

    } catch (error) {
      logError('Kat Sayı add to cart error:', error);
      showNotification(TRANSLATIONS.error || 'An error occurred', true);
    } finally {
      btn.classList.remove('qv-loading-btn');
      btn.disabled = false;
    }
  }

  // =====================
  // RETAIL FUNCTIONS
  // =====================

  // ✅ Render retail section - Grup fiyatlandırmasıyla
  function renderRetailSection() {
    const container = overlay.querySelector('.qv-size-inputs');
    container.innerHTML = '';

    const sizeOption = findOptionByType(currentProduct.options, ['size', 'beden', 'boyut']);
    const colorOption = findOptionByType(currentProduct.options, ['color', 'colour', 'renk']);
    const groupOption = findOptionByType(currentProduct.options, ['fiyat grubu', 'fiyat', 'grup', 'group', 'price', 'pricing']);

    if (!sizeOption) {
      // No size option, show single variant
      const variant = currentVariants.find(v => {
        let match = true;

        // Match group
        if (groupOption && selectedGroup) {
          match = match && v[`option${groupOption.position}`] === selectedGroup;
        }

        // Match color
        if (colorOption && selectedColor) {
          match = match && v[`option${colorOption.position}`] === selectedColor;
        }

        return match;
      });

      if (variant) {
        container.appendChild(createRetailSizeRow('Standart', variant));
      }
    } else {
      // Get sizes for selected color + group
      const sizes = bedenleriSirala(getOptionValues(sizeOption.position));

      sizes.forEach(sizeData => {
        // Find variant for this size + color + group
        const variant = currentVariants.find(v => {
          let match = v[`option${sizeOption.position}`] === sizeData.value;

          // Match group
          if (groupOption && selectedGroup) {
            match = match && v[`option${groupOption.position}`] === selectedGroup;
          }

          // Match color
          if (colorOption && selectedColor) {
            match = match && v[`option${colorOption.position}`] === selectedColor;
          }

          return match;
        });

        if (variant) {
          container.appendChild(createRetailSizeRow(sizeData.value, variant));
        }
      });
    }

    updateRetailTotal();
  }

  function createRetailSizeRow(sizeName, variant) {
    const row = document.createElement('div');
    row.className = 'qv-size-row';
    row.dataset.variantId = variant.id;

    const stock = variant.inventory_quantity || 0;
    const available = variant.available && stock > 0;

    if (!available) {
      row.classList.add('qv-out-of-stock');
    }

    // Stock class
    let stockClass = '';
    let stockText = `Stok: ${stock}`;
    if (stock === 0) {
      stockClass = 'qv-stock-out';
      stockText = TRANSLATIONS.outOfStock || 'OUT OF STOCK';
    } else if (stock <= 5) {
      stockClass = 'qv-stock-low';
    }

    row.innerHTML = `
      <span class="qv-size-name">${sizeName}</span>
      <span class="qv-size-stock ${stockClass}">${stockText}</span>
      <div class="qv-size-qty-wrapper">
        ${available ? `
          <button type="button" class="qv-qty-btn qv-qty-minus">-</button>
          <input type="number" class="qv-qty-input" value="0" min="0" max="${stock}" data-variant-id="${variant.id}" data-max="${stock}">
          <button type="button" class="qv-qty-btn qv-qty-plus">+</button>
        ` : `<span style="color: #999;">─</span>`}
      </div>
    `;

    if (available) {
      const minusBtn = row.querySelector('.qv-qty-minus');
      const plusBtn = row.querySelector('.qv-qty-plus');
      const input = row.querySelector('.qv-qty-input');

      minusBtn.addEventListener('click', () => {
        const val = Math.max(0, parseInt(input.value) - 1);
        input.value = val;
        updateRetailTotal();
      });

      plusBtn.addEventListener('click', () => {
        const max = parseInt(input.dataset.max);
        const val = Math.min(max, parseInt(input.value) + 1);
        input.value = val;
        updateRetailTotal();
      });

      input.addEventListener('change', () => {
        const max = parseInt(input.dataset.max);
        let val = parseInt(input.value) || 0;
        val = Math.max(0, Math.min(max, val));
        input.value = val;
        updateRetailTotal();
      });
    }

    return row;
  }

  function updateRetailTotal() {
    const inputs = retailSection.querySelectorAll('.qv-qty-input');
    let total = 0;
    inputs.forEach(input => {
      total += parseInt(input.value) || 0;
    });

    overlay.querySelector('.qv-retail-total-items').textContent = `${total} adet`;

    const addBtn = overlay.querySelector('.qv-add-retail');
    addBtn.disabled = total === 0;
  }

  async function addRetailToCart() {
    const btn = overlay.querySelector('.qv-add-retail');
    btn.classList.add('qv-loading-btn');
    btn.disabled = true;

    try {
      const inputs = retailSection.querySelectorAll('.qv-qty-input');
      const items = [];

      inputs.forEach(input => {
        const qty = parseInt(input.value) || 0;
        const variantId = input.dataset.variantId;
        if (qty > 0 && variantId) {
          items.push({
            id: parseInt(variantId),
            quantity: qty
          });
        }
      });

      if (items.length === 0) {
        throw new Error('No items to add');
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Add to cart failed');

      let totalAdded = 0;
      items.forEach(i => totalAdded += i.quantity);

      showNotification(`${totalAdded} adet sepete eklendi!`);

      refreshCart();
      // ✅ Modal açık kalsın - kullanıcı isterse kendisi kapatsın
      // setTimeout(closeModal, 1500);

    } catch (error) {
      logError('Add to cart error:', error);
      showNotification(TRANSLATIONS.error || 'An error occurred', true);
    } finally {
      btn.classList.remove('qv-loading-btn');
      updateRetailTotal();
    }
  }

  // =====================
  // UTILITY FUNCTIONS
  // =====================

  // ✅ KAT SAYI: Açıklamadan Kat Sayı değerini tespit et
  function detectKatSayi(description) {
    if (!description) return 0;

    // HTML temizle
    let cleanText = description.replace(/<[^>]*>/g, ' ');
    cleanText = cleanText.replace(/&[a-zA-Z0-9#]+;/g, ' ');
    cleanText = cleanText.replace(/\s+/g, ' ');

    // "Kat Sayı:" pattern'ini ara
    const katSayiMatch = cleanText.match(/Kat Sayı:\s*(\d+)/i);
    if (katSayiMatch) {
      const value = parseInt(katSayiMatch[1]);
      if (value > 0) {
        log('Kat Sayı detected:', value);
        return value;
      }
    }

    return 0;
  }

  // ✅ QUANTITY-MULTIPLIER.JS ile AYNI PARSE MANTIK - GÜNCELLENDİ
  function parseSetDistribution(description) {
    if (!description) return {};

    const distribution = {};
    let text = description.toString().trim();

    // ✅ YENİ: Önce "Set İçeriği:" keyword'ünden sonraki kısmı extract et
    const setIcerigiExtracted = extractSetIcerigiContent(text);
    if (setIcerigiExtracted) {
      log('Extracted Set İçeriği content:', setIcerigiExtracted);
      text = setIcerigiExtracted; // Sadece set içeriği kısmını parse et
    }

    // ✅ Set İçeriği formatı varsa özel parser kullan
    if (setIcerigiExtracted || /\d+-\d+-\d+/.test(text)) {
      log('Detected Set İçeriği format, using special parser');
      const setIcerigiResult = parseSetIcerigiFormat(text);
      if (Object.keys(setIcerigiResult).length > 0) {
        return setIcerigiResult;
      }
      log('Set İçeriği parser failed, continuing with normal parsing');
    }

    // HTML ve özel karakterleri temizle
    text = text.replace(/<[^>]*>/g, '');
    text = text.replace(/&[a-zA-Z0-9#]+;/g, '');
    text = text.replace(/[*]/g, '');
    text = text.replace(/[\r\n\t\f\v]/g, ' ');
    text = text.replace(/\s+/g, ' ');
    text = text.trim();

    log('Parsing set distribution:', text.substring(0, 200));

    const invalid = new Set(['TRY','USD','EUR','GBP','ADET','KG','TL','CM','MM','PIECE','ÖLÇÜ','TABLOSU','BOYUT']);

    // ✅ Bilinen bedenler - önce uzun olanlar (XXL vs XL karışmasın)
    const knownSizes = ['XXXL', 'XXL', 'XXS', '4XL', '3XL', '2XL', '2XS', 'XL', 'XS', 'S', 'M', 'L'];

    // ✅ YENİ: Tarih formatlarını kontrol et
    const isDateFormat = (str) => {
      // YYYY-MM, YYYY-MM-DD, DD-MM-YYYY gibi tarih formatlarını yakala
      return /^(19|20)\d{2}[-\/](0[1-9]|1[0-2])/.test(str) || // YYYY-MM
             /^(0[1-9]|[12]\d|3[01])[-\/](0[1-9]|1[0-2])[-\/](19|20)\d{2}/.test(str) || // DD-MM-YYYY
             /^\d{4}[-\/]\d{2}[-\/]\d{2}/.test(str); // YYYY-MM-DD
    };

    const addToDistribution = (size, qty) => {
      const s = String(size).toUpperCase().trim();
      const q = parseInt(qty, 10);
      if (!s || isNaN(q) || q <= 0 || invalid.has(s)) return false;

      // ✅ YENİ: Tarih formatlarını reddet
      if (isDateFormat(s)) {
        log(`Skipping date format: ${s}`);
        return false;
      }

      if (distribution[s]) {
        log(`Size ${s} already exists, skipping duplicate`);
        return false;
      }

      distribution[s] = q;
      log(`Added: ${s} = ${q}`);
      return true;
    };

    let matched = false;

    // ✅ FORMAT 1: Beden aralığı + miktar (3-4-1, 5-6-1, 7-8-2)
    // Tarih formatlarını hariç tut (YYYY-MM-DD gibi)
    const rangeWithQuantityMatches = [...text.matchAll(/(?:^|\s)(\d{1,2}-\d{1,2})-(\d+)(?=\s|$)/g)];
    if (rangeWithQuantityMatches.length > 0) {
      log(`FORMAT 1 - Range+Quantity: ${rangeWithQuantityMatches.length} matches`);
      for (const match of rangeWithQuantityMatches) {
        // Tarih olmadığından emin ol
        if (!isDateFormat(match[1]) && !isDateFormat(match[0])) {
          if (addToDistribution(match[1], match[2])) matched = true;
        }
      }
    }

    // ✅ FORMAT 2: Sadece beden aralığı (9-10 11-12 13-14) - miktar = 1
    // ÖNEMLİ: Sadece önceki format başarısız olursa dene
    if (!matched) {
      const rangeOnlyMatches = [...text.matchAll(/(?:^|\s)(\d{1,2}-\d{1,2})(?=\s|$)/g)];
      if (rangeOnlyMatches.length > 0) {
        log(`FORMAT 2 - Range-only: ${rangeOnlyMatches.length} matches`);
        for (const match of rangeOnlyMatches) {
          // Tarih olmadığından emin ol
          if (!isDateFormat(match[1]) && !isDateFormat(match[0])) {
            if (addToDistribution(match[1], 1)) matched = true;
          }
        }
      }
    }

    // ✅ FORMAT 3: BedenNumara formatı (1XL1-2XL1-3XL1-4XL1)
    // ÖNEMLİ: Sadece önceki formatlar başarısız olursa dene
    if (!matched) {
      const complexMatches = [...text.matchAll(/(\d+)([A-Z]{1,3})(\d+)/gi)];
      if (complexMatches.length > 0) {
        log(`FORMAT 3 - Complex (1XL1...): ${complexMatches.length} matches`);
        for (const match of complexMatches) {
          const fullSizeName = match[1] + match[2].toUpperCase(); // "1XL", "2XL"
          if (addToDistribution(fullSizeName, match[3])) matched = true;
        }
      }
    }

    // ✅ FORMAT 4: S1-M1-L1-XL1 (Standart beden+adet) - DOĞRU SIRALAMA İLE
    // ÖNEMLİ: Sadece önceki formatlar başarısız olursa dene
    if (!matched) {
      const escapedSizes = knownSizes.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      const sizePattern = new RegExp(`(${escapedSizes.join('|')})(\\d+)`, 'gi');
      const sizeMatches = [...text.matchAll(sizePattern)];
      if (sizeMatches.length > 0) {
        log(`FORMAT 4 - Standard (S1-M1...): ${sizeMatches.length} matches`);
        for (const match of sizeMatches) {
          if (addToDistribution(match[1], match[2])) matched = true;
        }
      }
    }

    // ✅ FORMAT 5: S-M-L-XL (Tire ile ayrılmış, adet yok = her birinden 1)
    // ÖNEMLİ: Sadece önceki formatlar başarısız olursa dene
    if (!matched) {
      const dashParts = text.split(/[-\s,|\/]+/).filter(part => {
        const cleaned = part.trim().toUpperCase();
        return cleaned.length > 0 &&
               !invalid.has(cleaned) &&
               /^[A-Z0-9]+$/.test(cleaned) &&
               !(/^\d+$/.test(cleaned) && cleaned.length > 2) &&
               !isDateFormat(cleaned); // Tarih formatlarını hariç tut
      });

      if (dashParts.length > 1) {
        log(`FORMAT 5 - Dash-separated: ${dashParts.length} parts`);
        for (const part of dashParts) {
          const cleanPart = part.trim().toUpperCase();
          if (knownSizes.includes(cleanPart) ||
              /^(XXS|XS|S|M|L|XL|XXL|XXXL|\d+XL|\d+L|2XS|3XL|4XL)$/i.test(cleanPart)) {
            if (addToDistribution(cleanPart, 1)) matched = true;
          }
        }
      }
    }

    // ✅ FORMAT 6: L-2 XL-4 2XL-4 3XL-2 (beden-adet tire ile ayrılmış)
    if (!matched) {
      const hyphenatedMatches = [...text.matchAll(/\b(\d*[SMLX]{1,3}L?)\s*-\s*(\d+)\b/gi)];
      if (hyphenatedMatches.length > 0) {
        log(`FORMAT 6 - Hyphenated (L-2, XL-4...): ${hyphenatedMatches.length} matches`);
        for (const match of hyphenatedMatches) {
          const size = match[1].toUpperCase();
          const quantity = match[2];
          const isValidSize = knownSizes.includes(size) || /^\d*[SMLX]{1,3}L?$/i.test(size);
          if (isValidSize && !invalid.has(size) && !isDateFormat(size)) {
            if (addToDistribution(size, quantity)) matched = true;
          }
        }
      }
    }

    // ✅ FORMAT 7: S:2, M:1 gibi kolon formatı
    if (!matched) {
      const colonMatches = [...text.matchAll(/([A-Z0-9]{1,4})\s*:\s*(\d+)/gi)];
      for (const match of colonMatches) {
        const size = match[1].toUpperCase();
        const quantity = match[2];
        if (!invalid.has(size) && !isDateFormat(size)) {
          if (addToDistribution(size, quantity)) matched = true;
        }
      }
    }

    // ✅ FORMAT 8: STD-X fallback
    if (!matched) {
      const stdMatch = text.match(/STD\s*[-:]\s*(\d+)/i);
      if (stdMatch) {
        const multiplier = parseInt(stdMatch[1]);
        log('STD format found:', multiplier);
        return { '__STD__': multiplier };
      }
    }

    // ✅ FORMAT 9: Fallback - Eğer hiçbir format eşleşmezse ve bilinen bedenler varsa
    if (!matched && Object.keys(distribution).length === 0) {
      log('No specific format found, trying to find known sizes in text');
      for (const size of knownSizes) {
        const sizeRegex = new RegExp(`\\b${size}\\b`, 'gi');
        if (sizeRegex.test(text)) {
          addToDistribution(size, 1);
          matched = true;
        }
      }
    }

    return distribution;
  }

  // ✅ YENİ: "Set İçeriği:" keyword'ünden sonraki içeriği extract et
  function extractSetIcerigiContent(text) {
    if (!text) return null;

    // HTML temizle
    let cleanText = text.replace(/<[^>]*>/g, ' ');
    cleanText = cleanText.replace(/&[a-zA-Z0-9#]+;/g, ' ');
    cleanText = cleanText.replace(/\s+/g, ' ');

    // "Set İçeriği:" pattern'ini ara
    const patterns = [
      /Set İçeriği:\s*([^\n<]+)/i,
      /Set Icerigi:\s*([^\n<]+)/i,
      /Set Content:\s*([^\n<]+)/i,
      /Asorti:\s*([^\n<]+)/i
    ];

    for (const pattern of patterns) {
      const match = cleanText.match(pattern);
      if (match && match[1]) {
        let content = match[1].trim();
        // İlk satırı al (Ölçü Tablosu gibi sonraki bölümleri dahil etme)
        content = content.split(/\s{2,}|Ölçü|ÖLÇÜ|Olcu|Table/i)[0].trim();
        if (content.length > 0) {
          return content;
        }
      }
    }

    return null;
  }

  // ✅ Set İçeriği formatı için özel parser (quantity-multiplier ile aynı) - GÜNCELLENDİ
  function parseSetIcerigiFormat(distributionText) {
    if (!distributionText) return {};

    const distribution = {};
    let text = distributionText.toString().trim();

    // Set İçeriği formatı için özel temizleme
    text = text.replace(/<[^>]*>/g, ' ');
    text = text.replace(/&[a-zA-Z0-9#]+;/g, ' ');
    text = text.replace(/[\r\n\t\f\v]/g, ' ');
    text = text.replace(/\s+/g, ' ');
    text = text.trim();

    log('Parsing Set İçeriği format:', text.substring(0, 200));

    // Invalid kelimelerden sonrasını kes
    const invalidWords = ['ÖLÇÜ', 'TABLOSU', 'CM', 'BOYUT', 'GENİŞLİĞİ', 'UZUNLUĞU'];
    for (const invalidWord of invalidWords) {
      if (text.toUpperCase().includes(invalidWord)) {
        const parts = text.toUpperCase().split(invalidWord);
        text = parts[0].trim();
        break;
      }
    }

    // Bilinen bedenler (uzundan kısaya sıralı - önce uzun olanlar eşleşsin)
    const knownSizes = ['XXXL', 'XXL', 'XXS', '4XL', '3XL', '2XL', '2XS', 'XL', 'XS', 'S', 'M', 'L'];

    // ✅ YENİ FORMAT: L-2 XL-4 2XL-4 3XL-2 (beden-adet tire ile ayrılmış)
    // Pattern: (opsiyonel numara + harf beden) + tire + adet
    // Örnekler: L-2, XL-4, 2XL-4, 3XL-2, S-1, M-3
    const hyphenatedMatches = [...text.matchAll(/\b(\d*[SMLX]{1,3}L?)\s*-\s*(\d+)\b/gi)];
    if (hyphenatedMatches.length > 0) {
      log(`Set İçeriği Hyphenated format (L-2, XL-4...): ${hyphenatedMatches.length} matches`);
      for (const match of hyphenatedMatches) {
        const size = match[1].toUpperCase();
        const quantity = parseInt(match[2], 10);
        // Geçerli beden olduğundan emin ol
        const isValidSize = knownSizes.includes(size) || /^\d*[SMLX]{1,3}L?$/i.test(size);
        if (isValidSize && !isNaN(quantity) && quantity > 0) {
          distribution[size] = quantity;
          log(`Added Hyphenated: ${size} = ${quantity}`);
        }
      }
      if (Object.keys(distribution).length > 0) {
        return distribution;
      }
    }

    // ✅ YENİ FORMAT: 1XL1-2XL1-3XL1-4XL1 (BedenNumara formatı)
    // Bu format Set İçeriği'nde sık kullanılıyor
    const complexMatches = [...text.matchAll(/(\d+)([A-Z]{1,3})(\d+)/gi)];
    if (complexMatches.length > 0) {
      log(`Set İçeriği Complex format (1XL1...): ${complexMatches.length} matches`);
      for (const match of complexMatches) {
        const fullSizeName = match[1] + match[2].toUpperCase(); // "1XL", "2XL"
        const quantity = parseInt(match[3], 10);
        if (!isNaN(quantity) && quantity > 0) {
          distribution[fullSizeName] = quantity;
          log(`Added Complex: ${fullSizeName} = ${quantity}`);
        }
      }
      if (Object.keys(distribution).length > 0) {
        return distribution;
      }
    }

    // ✅ YENİ FORMAT: S1-M1-L1-XL1 (Standart beden+adet bitişik)
    const escapedSizes = knownSizes.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const sizePattern = new RegExp(`(${escapedSizes.join('|')})(\\d+)`, 'gi');
    const standardMatches = [...text.matchAll(sizePattern)];
    if (standardMatches.length > 0) {
      log(`Set İçeriği Standard format (S1-M1...): ${standardMatches.length} matches`);
      for (const match of standardMatches) {
        const size = match[1].toUpperCase();
        const quantity = parseInt(match[2], 10);
        if (!isNaN(quantity) && quantity > 0) {
          distribution[size] = quantity;
          log(`Added Standard: ${size} = ${quantity}`);
        }
      }
      if (Object.keys(distribution).length > 0) {
        return distribution;
      }
    }

    // digit-digit-digit formatı (7-8-1, 9-10-2)
    const setIcerigiMatches = [...text.matchAll(/(\d+-\d+)-(\d+)/g)];
    if (setIcerigiMatches.length > 0) {
      log(`Set İçeriği format: ${setIcerigiMatches.length} matches`);
      for (const match of setIcerigiMatches) {
        const sizeRange = match[1];
        const quantity = parseInt(match[2], 10);
        if (!isNaN(quantity) && quantity > 0) {
          distribution[sizeRange] = quantity;
          log(`Added Set İçeriği: ${sizeRange} = ${quantity}`);
        }
      }
      return distribution;
    }

    // Boşlukla ayrılmış aralıklar (7-8 9-10)
    const spaceMatches = [...text.matchAll(/(\d+-\d+)/g)];
    if (spaceMatches.length > 0) {
      log(`Space-separated ranges: ${spaceMatches.length} matches`);
      for (const match of spaceMatches) {
        distribution[match[1]] = 1;
        log(`Added range: ${match[1]} = 1`);
      }
      return distribution;
    }

    log('No Set İçeriği format matches found');
    return {};
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const format = window.QuickviewConfig?.currency || '{{amount}} TL';
    return format.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents/100));
  }

  function showNotification(message, isError = false) {
    // Remove existing
    document.querySelectorAll('.qv-notification').forEach(n => n.remove());

    const notification = document.createElement('div');
    notification.className = 'qv-notification' + (isError ? ' qv-error' : '');
    notification.innerHTML = `<span>${isError ? '❌' : '✅'}</span><span>${message}</span>`;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'qv-slide-in 0.3s ease reverse';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  function refreshCart() {
    // Trigger cart refresh for different themes
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // Try common cart drawer triggers
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }

    // For Shopify Ajax Cart
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
  }

  const DEBUG = true;  // ✅ DEBUG AÇIK
  function log(...args) {
    if (DEBUG) console.log('[Quickview]', ...args);
  }

  function logError(...args) {
    console.error('[Quickview Error]', ...args);
  }

  // ===================== MULTI-ASORTI FUNCTIONS =====================

  /**
   * Handle'dan stokkodu ve asorti kodunu parse et
   * Format: {stokkodu}-{asortiKod} (örn: 5040057582-a)
   */
  function parseHandleForAsorti(handle) {
    if (!handle) return null;

    // Son '-' karakterinden ayır
    const lastDashIndex = handle.lastIndexOf('-');
    if (lastDashIndex === -1 || lastDashIndex === 0) return null;

    const potentialAsortiKod = handle.substring(lastDashIndex + 1);
    const potentialStokkodu = handle.substring(0, lastDashIndex);

    // Asorti kodu tek karakter (a, b, c, ...) olmalı
    if (potentialAsortiKod.length === 1 && /^[a-z]$/i.test(potentialAsortiKod)) {
      return {
        stokkodu: potentialStokkodu,
        asortiKod: potentialAsortiKod.toLowerCase()
      };
    }

    // Asorti kodu yok
    return null;
  }

  /**
   * Aynı stokkodu ile diğer asortileri kontrol et
   * a-f arası deneyip var olanları listeler
   */
  async function checkOtherAsortis() {
    if (!baseStokKodu) return;

    availableAsortis = [];
    const asortisToCheck = ['a', 'b', 'c', 'd', 'e', 'f'];

    log('Checking other asortis for:', baseStokKodu);

    for (const kod of asortisToCheck) {
      const testHandle = `${baseStokKodu}-${kod}`;

      try {
        const response = await fetch(`/products/${testHandle}.js`);
        if (response.ok) {
          const product = await response.json();
          availableAsortis.push({
            kod: kod,
            handle: testHandle,
            product: product,
            setContent: extractSetContentFromDescription(product.description)
          });
          log(`Asorti found: ${kod} (${testHandle})`);
        }
      } catch (e) {
        // Product not found - continue
      }
    }

    log(`Total asortis found: ${availableAsortis.length}`);
  }

  /**
   * Ürün açıklamasından set içeriğini çıkar
   */
  function extractSetContentFromDescription(description) {
    if (!description) return null;

    // HTML temizle
    const cleanDesc = description.replace(/<[^>]*>/g, ' ').trim();

    // "Set İçeriği:" pattern'i ara
    const match = cleanDesc.match(/Set İçeriği:\s*([^\n<]+)/i);
    if (match) {
      return match[1].trim();
    }

    // Alternatif: S1-M1-L1 formatını bul
    const sizeMatch = cleanDesc.match(/([SMLX]{1,3}\d+[-\s]*)+/i);
    if (sizeMatch) {
      return sizeMatch[0].trim();
    }

    return null;
  }

  /**
   * Asorti seçici render et
   * Birden fazla asorti varsa .qv-set-info yerine gösterilir
   */
  function renderAsortiSelector() {
    // Mevcut seçiciyi kaldır
    const existingSelector = overlay.querySelector('.qv-asorti-selector');
    if (existingSelector) existingSelector.remove();

    // .qv-set-info'yu göster (varsayılan durum)
    const setInfo = overlay.querySelector('.qv-set-info');

    if (availableAsortis.length <= 1) {
      // Tek asorti - normal set info göster
      if (setInfo) setInfo.style.display = '';
      return;
    }

    // Birden fazla asorti var - set info'yu gizle
    if (setInfo) setInfo.style.display = 'none';

    // Seçici container oluştur
    const selectorHtml = `
      <div class="qv-asorti-selector">
        <label class="qv-label">${TRANSLATIONS.setContent || 'Set Content'}:</label>
        <div class="qv-asorti-options">
          ${availableAsortis.map(asorti => `
            <button
              class="qv-asorti-btn ${asorti.kod === currentAsortiKod ? 'active' : ''}"
              data-asorti-kod="${asorti.kod}"
              data-asorti-handle="${asorti.handle}"
              title="${asorti.setContent || asorti.kod.toUpperCase()}"
            >
              ${asorti.setContent || asorti.kod.toUpperCase()}
            </button>
          `).join('')}
        </div>
      </div>
    `;

    // .qv-set-info'nun yerine ekle (varsa), yoksa info section'ın başına
    if (setInfo) {
      setInfo.insertAdjacentHTML('afterend', selectorHtml);
    } else {
      const infoSection = overlay.querySelector('.qv-info-section');
      if (infoSection) {
        infoSection.insertAdjacentHTML('afterbegin', selectorHtml);
      }
    }

    // Event listener'ları ekle
    const buttons = overlay.querySelectorAll('.qv-asorti-btn');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const kod = btn.dataset.asortiKod;
        const handle = btn.dataset.asortiHandle;
        if (kod !== currentAsortiKod) {
          switchAsorti(kod, handle);
        }
      });
    });

    log('Asorti selector rendered (replacing set-info)');
  }

  /**
   * Asorti değiştir
   */
  async function switchAsorti(kod, handle) {
    if (!handle) return;

    log(`Switching to asorti: ${kod} (${handle})`);

    // Loading state
    const asortiButtons = overlay.querySelectorAll('.qv-asorti-btn');
    asortiButtons.forEach(btn => {
      btn.disabled = true;
      if (btn.dataset.asortiKod === kod) {
        btn.classList.add('loading');
      }
    });

    const infoSection = overlay.querySelector('.qv-info-section');
    if (infoSection) infoSection.classList.add('loading');

    try {
      // Yeni ürünü yükle
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error('Product not found');

      const newProduct = await response.json();

      // State güncelle
      currentAsortiKod = kod;
      wholesaleHandle = handle;
      retailHandle = handle + RETAIL_SUFFIX;
      currentProduct = newProduct;
      wholesaleProduct = newProduct;
      currentVariants = newProduct.variants || [];

      // Stok bilgisini yükle
      await fetchInventoryData(handle);

      // UI güncelle
      renderProduct();

      // Asorti butonlarını güncelle (selector'ı yeniden render et)
      renderAsortiSelector();

      log(`Switched to asorti: ${kod}`);

    } catch (error) {
      logError('Failed to switch asorti:', error);
      showNotification(TRANSLATIONS.error || 'An error occurred', true);

      // Hata durumunda butonları resetle
      asortiButtons.forEach(btn => {
        btn.classList.remove('loading');
        btn.disabled = false;
      });
    }

    if (infoSection) infoSection.classList.remove('loading');
  }

  // ===================== END MULTI-ASORTI FUNCTIONS =====================

  // ===================== KZK CUP VARIANT FUNCTIONS =====================

  /**
   * Handle'dan Cup hane ve model parse et
   * Ornek: '3570570000' -> {hane:'35', cup:'D', modelWithAsorti:'70570000'}
   *        '3471100000-a' -> {hane:'34', cup:'C', modelWithAsorti:'71100000-a'}
   */
  function parseHandleForCup(handle) {
    if (!handle || handle.length < 6) return null;
    const hane = handle.slice(0, 2);
    if (!KZK_CUP_HANES.includes(hane)) return null;
    // Hane sonrasi rakam serisi (en az 4 hane), arkasinda asorti suffix olabilir
    const rest = handle.slice(2);
    if (!/^\d{4,}(-[a-z])?$/i.test(rest)) return null;
    return {
      hane,
      cup: KZK_CUP_BARKOD_MAP[hane],
      modelWithAsorti: rest.toLowerCase()
    };
  }

  /**
   * Diger Cup variantlarini paralel kontrol et
   * 33/34/35/37/38 hanelerini deneyip mevcut olanlari listele
   */
  async function checkOtherCups() {
    if (!cupBaseModel || !currentCupHane) return;

    availableCups = [];
    log('Checking Cup variants for model:', cupBaseModel);

    const checks = KZK_CUP_HANES.map(async (hane) => {
      const testHandle = `${hane}${cupBaseModel}`;
      try {
        const res = await fetch(`/products/${testHandle}.js`);
        if (res.ok) {
          const product = await res.json();
          return {
            hane,
            cup: KZK_CUP_BARKOD_MAP[hane],
            handle: testHandle,
            product
          };
        }
      } catch (e) { /* skip */ }
      return null;
    });

    const results = await Promise.all(checks);
    availableCups = results.filter(Boolean);

    // Mevcut Cup'in hane sirasina gore sirala
    availableCups.sort((a, b) => parseInt(a.hane) - parseInt(b.hane));

    log(`Cup variants found: ${availableCups.length}`, availableCups.map(c => c.cup));
  }

  /**
   * Cup secici buton grubunu render et (.qv-set-info'nun ustune)
   */
  function renderCupSelector() {
    const existing = overlay.querySelector('.qv-cup-selector');
    if (existing) existing.remove();

    if (availableCups.length <= 1) return;

    // Ic giyim urunlerinde matrix UI'nin kendi cup seciici var - duplikasyonu engelle
    if (isUnderwearProduct()) return;

    const html = `
      <div class="qv-cup-selector" style="margin: 12px 0; padding: 8px 0; border-top: 1px solid #eee; border-bottom: 1px solid #eee;">
        <label class="qv-label" style="display:block; margin-bottom:6px; font-weight:600;">Cup:</label>
        <div class="qv-cup-options" style="display:flex; gap:6px; flex-wrap:wrap;">
          ${availableCups.map(c => `
            <button
              type="button"
              class="qv-cup-btn ${c.hane === currentCupHane ? 'active' : ''}"
              data-cup-hane="${c.hane}"
              data-cup-handle="${c.handle}"
              style="
                padding: 6px 14px;
                border: 2px solid ${c.hane === currentCupHane ? '#000' : '#ddd'};
                background: ${c.hane === currentCupHane ? '#000' : '#fff'};
                color: ${c.hane === currentCupHane ? '#fff' : '#333'};
                cursor: pointer;
                border-radius: 4px;
                font-weight: 600;
                min-width: 38px;
              "
            >${c.cup}</button>
          `).join('')}
        </div>
      </div>
    `;

    // Color selector'in altina ekle
    const colorSelector = overlay.querySelector('.qv-color-selector');
    if (colorSelector) {
      colorSelector.insertAdjacentHTML('afterend', html);
    } else {
      const setInfo = overlay.querySelector('.qv-set-info');
      if (setInfo) setInfo.insertAdjacentHTML('beforebegin', html);
    }

    // Click handlers
    overlay.querySelectorAll('.qv-cup-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const hane = btn.dataset.cupHane;
        const newHandle = btn.dataset.cupHandle;
        if (hane !== currentCupHane) switchCup(hane, newHandle);
      });
    });

    log('Cup selector rendered');
  }

  /**
   * Cup degistir - yeni urunu yukle (asorti switch ile ayni mantik)
   */
  async function switchCup(hane, handle) {
    if (!handle) return;
    log(`Switching to Cup: ${KZK_CUP_BARKOD_MAP[hane]} (${handle})`);

    // KZK: urun sayfasinda (inline) cup degisince H1 baslik ve "Cup:/Urun:" aciklama bloku
    // overlay DISINDA kaldigi icin AJAX swap onlari guncelleyemiyor -> paketleme (Askili/Kutulu) gibi
    // tam sayfa reload yap; secilen cup urununun gercek basligi/aciklamasi/barkodu sunucudan gelir.
    // (Paketleme suffix'i cupBaseModel icinde korunur, yeni handle dogru paketlemeyi tasir.)
    if (__qvInlineActive) {
      if (productSection) productSection.style.display = 'none';
      if (loading) {
        loading.style.display = 'flex';
        const span = loading.querySelector('span');
        if (span) span.textContent = 'Cup değiştiriliyor...';
      }
      // Secimler kaybolmasin: paketleme handle'dan turetilir, cup parametreye yazilir.
      const pkgDeger = handle.endsWith(PACKAGING_SUFFIX) ? 'kutulu' : 'askili';
      window.location.href = '/products/' + handle + '?paketleme=' + pkgDeger + '&cup=' + hane;
      return;
    }

    const buttons = overlay.querySelectorAll('.qv-cup-btn');
    buttons.forEach(b => { b.disabled = true; });

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('Product not found');
      const newProduct = await res.json();

      // State guncelle
      currentCupHane = hane;
      wholesaleHandle = handle;
      retailHandle = handle + RETAIL_SUFFIX;
      currentProduct = newProduct;
      wholesaleProduct = newProduct;
      currentVariants = newProduct.variants || [];

      await fetchInventoryData(handle);
      renderProduct();
      renderCupSelector();
      // Asorti tablosu da yenilensin (yeni Cup'in asortilari farkli olabilir)
      if (availableAsortis.length > 1) renderAsortiSelector();
    } catch (error) {
      logError('Failed to switch Cup:', error);
      showNotification(TRANSLATIONS.error || 'An error occurred', true);
      buttons.forEach(b => { b.disabled = false; });
    }
  }

  // ===================== END KZK CUP VARIANT FUNCTIONS =====================

  // ===================== KZK PAKETLEME (Askili / Kutulu) =====================
  // Pattern: handle '-a' suffix'i = Kutulu; suffix yok = Askili.
  // Quickview acilinca paralel handle'i (alternatif paketleme) fetch eder,
  // varsa 'Paketleme:' satirinda iki buton gosterir; tiklanan handle'e gecer.
  const PACKAGING_SUFFIX = '-a';
  const _pkgCheckCache = new Map(); // handle -> exists boolean

  async function setupPackagingOptions() {
    const row = overlay.querySelector('.qv-packaging-row');
    const container = overlay.querySelector('.qv-packaging-options');
    if (!row || !container) return;
    if (!currentProduct) {
      row.style.display = 'none';
      return;
    }
    // Paketleme artik ust satirda degil: paket:askili/paket:kutulu etiketiyle matrisin altinda secilir; etiketsiz
    // urunde secim yoktur. Eski handle '-a' akisi (asagisi) devre disi: kutulu tek urunler yanlislikla 'Askili' cikiyordu.
    row.style.display = 'none';
    kzkAdimPaketleme = true;
    return;
    // Mevcut handle (suffix'siz versiyonu base alir)
    const handle = currentProduct.handle;
    const isKutulu = handle.endsWith(PACKAGING_SUFFIX);
    const baseHandle = isKutulu ? handle.slice(0, -PACKAGING_SUFFIX.length) : handle;
    const altHandle = isKutulu ? baseHandle : (baseHandle + PACKAGING_SUFFIX);

    // Retail suffix (-r) ekli versiyonlarini hesaba katma - sadece sade handle'lar
    if (baseHandle.endsWith(RETAIL_SUFFIX)) {
      row.style.display = 'none';
      return;
    }

    // Alternatif handle'i fetch (cache'li)
    let altExists = _pkgCheckCache.get(altHandle);
    if (altExists === undefined) {
      try {
        const r = await fetch(`/products/${altHandle}.js`, { method: 'GET' });
        altExists = r.ok;
      } catch (e) {
        altExists = false;
      }
      _pkgCheckCache.set(altHandle, altExists);
    }

    // Alternatifi yok (ornek: C cup'in Kutulu versiyonu yok): satiri gizlemek
    // yerine mevcut paketlemeyi tek, secili buton olarak gosteririz - musteri
    // hangi paketlemede oldugunu gorsun, adim da otomatik tamamlansin.
    if (!altExists) {
      container.innerHTML = '';
      const tek = document.createElement('button');
      tek.type = 'button';
      tek.textContent = isKutulu ? 'Kutulu' : 'Askılı';
      tek.className = 'qv-pkg-btn is-active';
      tek.disabled = true;
      tek.title = 'Bu üründe tek paketleme seçeneği var';
      container.appendChild(tek);
      row.style.display = '';
      kzkAdimPaketleme = true;
      const bolum = overlay.querySelector('.qv-detailed-section');
      if (bolum && bolum.style.display !== 'none') renderDetailedSection();
      return;
    }

    // Iki buton render
    container.innerHTML = '';
    // Secim URL'den okunur: /products/3371100000-a?paketleme=kutulu
    // Parametre yoksa HICBIRI secili degildir - musteri bilincli olarak secer.
    let secilenPkg = '';
    try {
      secilenPkg = (new URLSearchParams(window.location.search).get('paketleme') || '').toLowerCase();
    } catch (e) { secilenPkg = ''; }
    // Parametre bulundugumuz urunle celisiyorsa yok sayilir
    if (secilenPkg === 'kutulu' && !isKutulu) secilenPkg = '';
    if (secilenPkg === 'askili' && isKutulu) secilenPkg = '';

    const askiliBtn = document.createElement('button');
    askiliBtn.type = 'button';
    askiliBtn.textContent = 'Askılı';
    askiliBtn.dataset.target = baseHandle;
    askiliBtn.dataset.deger = 'askili';
    askiliBtn.className = 'qv-pkg-btn' + (secilenPkg === 'askili' ? ' is-active' : '');
    container.appendChild(askiliBtn);

    const kutuluBtn = document.createElement('button');
    kutuluBtn.type = 'button';
    kutuluBtn.textContent = 'Kutulu';
    kutuluBtn.dataset.target = baseHandle + PACKAGING_SUFFIX;
    kutuluBtn.dataset.deger = 'kutulu';
    kutuluBtn.className = 'qv-pkg-btn' + (secilenPkg === 'kutulu' ? ' is-active' : '');
    container.appendChild(kutuluBtn);

    // URL'de gecerli bir secim varsa 1. adim tamamlanmis sayilir
    if (secilenPkg) kzkAdimPaketleme = true;

    // Click handler - navigate ile YENI sayfa yukle (fiyat/cup/renk hepsi temiz state ile gelsin)
    // Sayfa yuklenirken qv-loading goruunur, kullanici gec değişimi anlasin.
    [askiliBtn, kutuluBtn].forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.target;
        const deger = btn.dataset.deger;

        // Bulundugumuz urunun paketlemesi secildi: sayfa yenilenmez,
        // URL'e parametre yazilir ve cup adimi acilir.
        if (target === handle) {
          container.querySelectorAll('.qv-pkg-btn').forEach(x => x.classList.remove('is-active'));
          btn.classList.add('is-active');
          try {
            const u = new URL(window.location.href);
            u.searchParams.set('paketleme', deger);
            window.history.replaceState({}, '', u.toString());
          } catch (e) { /* URL yazilamazsa akis yine devam eder */ }
          kzkAdimPaketleme = true;
          renderDetailedSection();
          return;
        }
        // Loading goster: urun bolumu gizli, spinner aktif
        if (productSection) productSection.style.display = 'none';
        if (loading) {
          loading.style.display = 'flex';
          // Loading icine 'Paketleme degisiyor...' yazisi ekle
          const span = loading.querySelector('span');
          if (span) span.textContent = 'Paketleme değiştiriliyor...';
        }
        // Inline mode: ayni overlay'in icindeki content'i navigate edemeyiz, full page reload
        window.location.href = '/products/' + target + '?paketleme=' + deger;
      });
    });

    row.style.display = '';

    // URL'den gelen secim varsa matris bolumu bekleyen mesajda kalmasin
    if (kzkAdimPaketleme) {
      const bolum = overlay.querySelector('.qv-detailed-section');
      if (bolum && bolum.style.display !== 'none') renderDetailedSection();
    }
  }
  // =================== END PAKETLEME =====================

  // Public API
  window.QuickviewModal = {
    open: openModal,
    close: closeModal
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
